import { blackTextColor } from "assets/styles/colors";

export const BackIcon = (props) => {
  const { white, onClick, className, height = "24" } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="15"
        height={height}
        viewBox="0 0 15 24"
        fill={white ? "#ffffff" : ""}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.481 1.50083C14.3087 2.32971 14.3087 3.6736 13.481 4.50249L5.99457 12L13.481 19.4975C14.3087 20.3264 14.3087 21.6703 13.481 22.4992C12.6534 23.3281 11.3115 23.3281 10.4838 22.4992L9.7892e-05 12L10.4838 1.50083C11.3115 0.671944 12.6534 0.671944 13.481 1.50083Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export const CardIcon = (props) => {
  const { className, width = "33", height = "32" } = props;
  return (
    <div className={className}>
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 33 32" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M0.5 8C0.5 5.79086 2.29086 4 4.5 4H28.5C30.7091 4 32.5 5.79086 32.5 8V24C32.5 26.2091 30.7091 28 28.5 28H4.5C2.29086 28 0.5 26.2091 0.5 24V8ZM4.5 6C3.39543 6 2.5 6.89543 2.5 8V10H30.5V8C30.5 6.89543 29.6046 6 28.5 6H4.5ZM30.5 14H2.5V24C2.5 25.1046 3.39543 26 4.5 26H28.5C29.6046 26 30.5 25.1046 30.5 24V14Z" 
          fill="#DB4E3B"
        />
        <path 
          d="M4.5 20C4.5 18.8954 5.39543 18 6.5 18H8.5C9.60457 18 10.5 18.8954 10.5 20V22C10.5 23.1046 9.60457 24 8.5 24H6.5C5.39543 24 4.5 23.1046 4.5 22V20Z" 
          fill="#DB4E3B"
        />
      </svg>
    </div>
  );
};

export const PaymentSuccessIcon = (props) => {
  const { className, width = "55", height = "54" } = props || {};
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 55 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M54.5 27C54.5 41.9117 42.4117 54 27.5 54C12.5883 54 0.5 41.9117 0.5 27C0.5 12.0883 12.5883 0 27.5 0C42.4117 0 54.5 12.0883 54.5 27ZM41.1023 16.7726C40.1138 15.7841 38.5111 15.7841 37.5226 16.7726C37.4987 16.7965 37.4763 16.8218 37.4555 16.8484L25.7362 31.7815L18.6706 24.7159C17.6821 23.7274 16.0794 23.7274 15.0909 24.7159C14.1023 25.7044 14.1023 27.3071 15.0909 28.2956L24.0226 37.2274C25.0111 38.2159 26.6138 38.2159 27.6023 37.2274C27.6244 37.2053 27.6451 37.1821 27.6646 37.1578L41.1383 20.3157C42.0907 19.3246 42.0787 17.749 41.1023 16.7726Z" fill="#B8CD82"/>
      </svg>
    </div>
  );
};

export const PaymentFailureIcon = (props) => {
  const { className, width = "55", height = "54" } = props || {};
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M27.5 50.625C14.4523 50.625 3.875 40.0477 3.875 27C3.875 13.9523 14.4523 3.375 27.5 3.375C40.5477 3.375 51.125 13.9523 51.125 27C51.125 40.0477 40.5477 50.625 27.5 50.625ZM27.5 54C42.4117 54 54.5 41.9117 54.5 27C54.5 12.0883 42.4117 0 27.5 0C12.5883 0 0.5 12.0883 0.5 27C0.5 41.9117 12.5883 54 27.5 54Z" fill="#DB4E3B"/>
        <path d="M24.1302 37.125C24.1302 35.261 25.6412 33.75 27.5052 33.75C29.3692 33.75 30.8802 35.261 30.8802 37.125C30.8802 38.989 29.3692 40.5 27.5052 40.5C25.6412 40.5 24.1302 38.989 24.1302 37.125Z" fill="#DB4E3B"/>
        <path d="M24.4608 16.8583C24.281 15.0602 25.693 13.5 27.5 13.5C29.307 13.5 30.719 15.0602 30.5392 16.8582L29.3554 28.6959C29.2601 29.6491 28.458 30.375 27.5 30.375C26.542 30.375 25.7399 29.6491 25.6446 28.6959L24.4608 16.8583Z" fill="#DB4E3B"/>
      </svg>
    </div>
  );
};

export const IconCall = (props) => {
  return (
    <svg
      width="40"
      height="44"
      viewBox="0 0 40 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4564_20950)">
        <path
          d="M24.5916 17.2524H15.3721L2.75684 31.4195V39.1785H37.2434V31.4195L24.5916 17.2524Z"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.37158 39.2332V42.6654"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.6284 39.2332V42.6654"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.3721 15.3721V17.2525"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.6099 15.3721V17.2525"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.0884 29.2288C26.0884 32.588 23.3682 35.3264 19.9907 35.3264C16.6133 35.3264 13.8931 32.6062 13.8931 29.2288C13.8931 25.8513 16.6133 23.1311 19.9907 23.1311C23.3682 23.1311 26.0884 25.8513 26.0884 29.2288Z"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.0091 31.748C21.4006 31.748 22.5285 30.6201 22.5285 29.2286C22.5285 27.8372 21.4006 26.7092 20.0091 26.7092C18.6177 26.7092 17.4897 27.8372 17.4897 29.2286C17.4897 30.6201 18.6177 31.748 20.0091 31.748Z"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.6674 6.93742C37.2434 2.77493 31.1457 0.80323 20.0092 0.912769C8.87278 0.80323 2.75685 2.77493 1.33284 6.93742C0.894687 8.23363 0.87643 11.3737 0.9312 12.7247C0.9312 13.1264 1.27807 13.4367 1.69797 13.4367L12.6336 13.4915C13.0535 13.4915 13.3821 13.1811 13.4004 12.7795C13.4004 12.7795 13.4552 9.74892 13.4734 9.7124C14.2037 7.57639 25.7966 7.55814 26.5268 9.7124C26.5268 9.76717 26.5998 12.7795 26.5998 12.7795C26.5998 13.1811 26.9467 13.4915 27.3666 13.4915L38.3023 13.4367C38.7039 13.4367 39.0508 13.1264 39.069 12.7247C39.1238 11.3737 39.1055 8.23363 38.6674 6.93742V6.93742Z"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4564_20950">
          <rect width="40" height="43.5783" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconUser = (props) => {
  const { white } = props;
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 44 44"
      fill={white ? "#ffffff" : ""}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4564_20962)">
        <path
          d="M35.7608 37.2962C44.3207 29.578 45.003 16.3821 37.2849 7.82229C29.5667 -0.737554 16.3708 -1.41988 7.81098 6.29826C-0.748865 14.0164 -1.4312 27.2123 6.28695 35.7722C14.0051 44.332 27.201 45.0143 35.7608 37.2962Z"
          stroke="#0D1013"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.6783 37.3542C31.1472 35.4754 26.7634 33.3019 26.3397 31.9389V30.1154C27.5554 28.8813 28.4948 27.1499 29.0658 25.1238C30.4104 24.1844 30.7604 22.2135 29.6368 20.8321V16.743C29.6368 12.5066 27.2791 9.61475 21.9007 9.61475C16.5223 9.61475 14.1646 12.5066 14.1646 16.743V20.8321C13.041 22.2135 13.391 24.1844 14.7356 25.1238C15.3066 27.1499 16.246 28.8629 17.4616 30.1154V31.9389C17.038 33.3204 12.9121 35.3465 8.32568 37.2437"
          stroke="#0D1013"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4564_20962">
          <rect width="43.58" height="43.58" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconHide = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={"none"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4358_16286)">
          <path
            d="M0.649902 22.86L23.0099 0.5"
            stroke="#6B6B6B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.84977 13.2997C6.41977 9.78974 9.92977 6.26973 13.4498 7.69973"
            stroke="#6B6B6B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.11 5.0293C10.29 2.7193 3.71 5.3693 0.5 11.6693C1.51 13.6393 2.89 15.3293 4.54 16.5993"
            stroke="#6B6B6B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.81 10.0605C17.23 13.5605 13.74 17.1005 10.21 15.6605"
            stroke="#6B6B6B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5498 18.32C13.3698 20.63 19.9498 17.98 23.1598 11.68C22.1498 9.71 20.7698 8.02 19.1198 6.75"
            stroke="#6B6B6B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.7198 12.1504C13.5498 12.8504 12.9998 13.3904 12.2998 13.5704"
            stroke="#6B6B6B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.21 15.6605C13.74 17.1005 17.24 13.5605 15.81 10.0605"
            stroke="#6B6B6B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.3599 9.78906C10.6599 9.95906 10.1199 10.5091 9.93994 11.2091"
            stroke="#6B6B6B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.2998 13.5704C12.9998 13.4004 13.5398 12.8504 13.7198 12.1504"
            stroke="#6B6B6B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4358_16286">
            <rect width="23.66" height="23.36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const IconReveal = (props) => {
  const { className, onClick, color = "#6B6B6B" } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="24"
        height="17"
        viewBox="0 0 24 17"
        fill={"none"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1606_20521)">
          <path
            d="M15.9699 8.00997C15.9699 10.52 13.9999 12.55 11.5599 12.55C9.1199 12.55 7.1499 10.52 7.1499 8.00997C7.1499 5.49997 9.1199 3.46997 11.5599 3.46997C13.9999 3.46997 15.9699 5.49997 15.9699 8.00997Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.37 8.01002C13.37 9.04001 12.56 9.88001 11.56 9.88001C10.56 9.88001 9.75 9.04001 9.75 8.01002C9.75 6.98002 10.56 6.14001 11.56 6.14001C12.56 6.14001 13.37 6.98002 13.37 8.01002Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.62 8.01C20.4 3.52 16.28 0.5 11.56 0.5C6.84 0.5 2.72 3.52 0.5 8.01C2.72 12.5 6.84 15.52 11.56 15.52C16.28 15.52 20.4 12.5 22.62 8.01Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1606_20521">
            <rect width="23.12" height="16.02" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const IconCheckMark = (props) => {
  const { color, className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="27"
        height="26"
        viewBox="0 0 27 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 1C6.36731 1 1 6.36731 1 13C1 19.6327 6.36731 25 13 25C19.6327 25 25.0105 19.6221 25.0105 13C25.0105 6.37786 19.6327 1 13 1Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.79102 13.3588L11.2919 17.7349L18.8314 8.31836"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconHome = (props) => {
  const { color, className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="24"
        height="23"
        viewBox="0 0 27 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.8435 9.89062V24.9997H3.11621V9.90153"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.7524 8.95362V2.0918H17.2979V4.27362"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 11.7236L13.4909 1L25.9818 11.7236"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconSettings = (props) => {
  const { color, className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4979_13627)">
          <path
            d="M16.2462 12.0006C16.2462 14.3493 14.3385 16.257 11.9898 16.257C9.64109 16.257 7.7334 14.3493 7.7334 12.0006C7.7334 9.65183 9.64109 7.74414 11.9898 7.74414C14.3385 7.74414 16.2462 9.65183 16.2462 12.0006Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.256 13.9893L23.3637 13.579C23.5073 12.5226 23.5176 11.5072 23.3637 10.4098L20.256 9.99951C20.0509 9.12771 19.7022 8.3072 19.2509 7.56874L21.1688 5.07643C20.5329 4.22515 19.774 3.47643 18.9227 2.83028L16.4304 4.74823C15.6817 4.28669 14.8714 3.94823 13.9894 3.73284L13.5791 0.62515C12.5022 0.471304 11.4765 0.471304 10.4099 0.62515L9.99961 3.73284C9.12781 3.93797 8.3073 4.28669 7.55858 4.74823L5.06627 2.83028C4.25602 3.44566 3.47653 4.20464 2.82012 5.07643L4.72781 7.56874C4.26627 8.31746 3.92781 9.13797 3.71243 10.0098L0.604736 10.42C0.461146 11.4251 0.45089 12.5021 0.604736 13.5893L3.71243 13.9995C3.92781 14.8713 4.26627 15.6918 4.72781 16.4405L2.82012 18.9328C3.4355 19.7431 4.19448 20.5226 5.06627 21.179L7.55858 19.261C8.3073 19.7226 9.12781 20.061 9.99961 20.2764L10.4099 23.3841C11.4868 23.5277 12.5022 23.538 13.5791 23.3841L13.9894 20.2764C14.8611 20.061 15.6817 19.7226 16.4304 19.261L18.9227 21.1687C19.774 20.5226 20.5227 19.7739 21.1688 18.9226L19.2509 16.4303C19.7022 15.6816 20.0509 14.8713 20.256 13.9995V13.9893Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4979_13627">
            <rect width="23.9897" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const IconNavbarUser = (props) => {
  const { color, className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9625 20.1849C17.3573 19.1047 14.8369 17.8551 14.5933 17.0714V16.023C15.2923 15.3135 15.8324 14.318 16.1607 13.1531C16.9337 12.613 17.1349 11.4799 16.489 10.6856V8.33466C16.489 5.89896 15.1334 4.23633 12.0412 4.23633C8.94888 4.23633 7.59336 5.89896 7.59336 8.33466V10.6856C6.94737 11.4799 7.14858 12.613 7.92165 13.1531C8.24994 14.318 8.79003 15.3029 9.48897 16.023V17.0714C9.2454 17.8657 6.87324 19.0306 4.23633 20.1213"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="11" stroke={color} strokeWidth="2" />
      </svg>
    </div>
  );
};

export const AppleStoreIcon = () => {
  return (
    <div>
      <svg
        width="130"
        height="39"
        viewBox="0 0 130 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M125.32 38.48H4.55C2.015 38.48 0 36.4 0 33.93V4.55C0 2.015 2.015 0 4.55 0H125.385C127.92 0 130 2.015 130 4.55V33.93C130 36.4 127.855 38.48 125.32 38.48Z"
          fill="#A6A6A6"
        />
        <path
          d="M129.026 33.9327C129.026 35.9477 127.401 37.6376 125.321 37.6376H4.55071C2.53571 37.6376 0.845703 36.0127 0.845703 33.9327V4.55266C0.845703 2.53766 2.47071 0.847656 4.55071 0.847656H125.386C127.401 0.847656 129.091 2.47266 129.091 4.55266L129.026 33.9327Z"
          fill="black"
        />
        <path
          d="M28.9901 18.9721C28.9901 15.8521 31.5251 14.3571 31.6551 14.2921C30.2251 12.1471 27.9501 11.8871 27.1701 11.8871C25.2851 11.6921 23.4651 12.9921 22.4901 12.9921C21.5151 12.9921 20.0201 11.8871 18.3951 11.8871C16.3151 11.8871 14.4301 13.1221 13.3251 14.9421C11.1151 18.7121 12.7401 24.3021 14.8851 27.3571C15.9251 28.8521 17.1601 30.5421 18.7201 30.4771C20.2801 30.4121 20.8651 29.5021 22.7501 29.5021C24.6351 29.5021 25.1551 30.4771 26.7801 30.4771C28.4701 30.4771 29.5101 28.9821 30.5501 27.4871C31.7851 25.7971 32.2401 24.1071 32.2401 23.9771C32.2401 23.9121 28.9901 22.7421 28.9901 18.9721Z"
          fill="white"
        />
        <path
          d="M25.9347 9.87907C26.7797 8.83907 27.3647 7.40906 27.1697 5.91406C25.9347 5.97906 24.4397 6.75908 23.5297 7.79908C22.7497 8.70908 22.0347 10.2041 22.2297 11.5691C23.5947 11.6991 25.0247 10.9191 25.9347 9.87907Z"
          fill="white"
        />
        <path
          d="M51.6099 30.2894H49.3999L48.2299 26.5194H44.0699L42.8999 30.2894H40.7549L44.8499 17.4844H47.3849L51.6099 30.2894ZM47.9049 24.9594L46.7999 21.6444C46.6699 21.3194 46.4749 20.4744 46.1499 19.2394H46.0849C45.9549 19.7594 45.7599 20.6044 45.4999 21.6444L44.4599 24.9594H47.9049Z"
          fill="white"
        />
        <path
          d="M62.2698 25.5525C62.2698 27.1125 61.8148 28.3475 60.9698 29.2575C60.1898 30.0375 59.2798 30.4925 58.1098 30.4925C56.8748 30.4925 56.0298 30.0375 55.5098 29.1925H55.4448V34.0675H53.3648V24.1225C53.3648 23.1475 53.3648 22.1075 53.2998 21.0675H55.1198L55.2498 22.5625H55.3148C56.0298 21.4575 57.0698 20.9375 58.4348 20.9375C59.5398 20.9375 60.4498 21.3925 61.1648 22.2375C61.8798 23.0175 62.2698 24.1225 62.2698 25.5525ZM60.1248 25.6175C60.1248 24.7075 59.9298 23.9925 59.5398 23.4075C59.0848 22.8225 58.4998 22.4975 57.7848 22.4975C57.2648 22.4975 56.8098 22.6925 56.4198 23.0175C56.0298 23.3425 55.7698 23.7975 55.6398 24.3175C55.5748 24.5775 55.5748 24.7725 55.5748 24.9675V26.5275C55.5748 27.1775 55.7698 27.7625 56.2248 28.2175C56.6148 28.6725 57.1998 28.9325 57.8498 28.9325C58.6298 28.9325 59.2148 28.6075 59.6698 28.0225C59.9298 27.3725 60.1248 26.5925 60.1248 25.6175Z"
          fill="white"
        />
        <path
          d="M72.8655 25.5525C72.8655 27.1125 72.4105 28.3475 71.5655 29.2575C70.7855 30.0375 69.8755 30.4925 68.7055 30.4925C67.4705 30.4925 66.6255 30.0375 66.1055 29.1925H66.0405V34.0675H63.9605V24.1225C63.9605 23.1475 63.9605 22.1075 63.8955 21.0675H65.7155L65.8455 22.5625H65.9105C66.6255 21.4575 67.6005 20.9375 69.0305 20.9375C70.1355 20.9375 71.0455 21.3925 71.7605 22.2375C72.4755 23.0175 72.8655 24.1225 72.8655 25.5525ZM70.7855 25.6175C70.7855 24.7075 70.5905 23.9925 70.2005 23.4075C69.7455 22.8225 69.1605 22.4975 68.4455 22.4975C67.9255 22.4975 67.4705 22.6925 67.0805 23.0175C66.6905 23.3425 66.4305 23.7975 66.3005 24.3175C66.2355 24.5775 66.2355 24.7725 66.2355 24.9675V26.5275C66.2355 27.1775 66.4305 27.7625 66.8205 28.2175C67.2105 28.6725 67.7955 28.9325 68.4455 28.9325C69.2255 28.9325 69.8105 28.6075 70.2655 28.0225C70.5905 27.3725 70.7855 26.5925 70.7855 25.6175Z"
          fill="white"
        />
        <path
          d="M84.7596 26.7141C84.7596 27.8191 84.3696 28.6641 83.5896 29.3791C82.7446 30.1591 81.5746 30.4841 80.0796 30.4841C78.7146 30.4841 77.6096 30.2241 76.7646 29.7041L77.2197 28.0141C78.1297 28.5341 79.1046 28.8591 80.2096 28.8591C80.9896 28.8591 81.5746 28.6641 82.0296 28.3391C82.4846 28.0141 82.6796 27.4941 82.6796 26.9091C82.6796 26.3891 82.4846 25.9341 82.1596 25.6091C81.8346 25.2841 81.1846 24.8941 80.4046 24.6341C78.1296 23.7891 77.0246 22.5541 77.0246 20.9291C77.0246 19.8891 77.4147 19.0441 78.1947 18.3291C78.9747 17.6791 80.0146 17.2891 81.3146 17.2891C82.4846 17.2891 83.4596 17.4841 84.2396 17.8741L83.7197 19.5641C83.0047 19.1741 82.1596 18.9791 81.2496 18.9791C80.5346 18.9791 79.9496 19.1741 79.5596 19.4991C79.2346 19.8241 79.0396 20.2141 79.0396 20.6691C79.0396 21.1891 79.2346 21.5791 79.6246 21.9041C79.9496 22.2291 80.5996 22.5541 81.5096 22.8791C82.6146 23.3341 83.3946 23.8541 83.9146 24.4391C84.4996 25.0891 84.7596 25.8041 84.7596 26.7141Z"
          fill="white"
        />
        <path
          d="M91.5193 22.6182H89.3093V27.1032C89.3093 28.2732 89.6992 28.7932 90.4792 28.7932C90.8692 28.7932 91.1293 28.7932 91.3893 28.7282L91.4542 30.2882C91.0642 30.4182 90.5442 30.5482 89.8292 30.5482C89.0492 30.5482 88.3993 30.2882 87.9443 29.8332C87.4893 29.3132 87.2292 28.5332 87.2292 27.3632V22.6182H85.8643V21.0582H87.2292V19.3682L89.2443 18.7832V21.0582H91.5193V22.6182Z"
          fill="white"
        />
        <path
          d="M101.725 25.6175C101.725 27.0475 101.335 28.2175 100.49 29.1275C99.645 30.0375 98.54 30.5575 97.11 30.5575C95.745 30.5575 94.705 30.1025 93.86 29.1925C93.08 28.2825 92.625 27.1775 92.625 25.8125C92.625 24.3825 93.015 23.2125 93.86 22.3025C94.705 21.3925 95.81 20.9375 97.24 20.9375C98.605 20.9375 99.71 21.3925 100.49 22.3025C101.335 23.0825 101.725 24.1875 101.725 25.6175ZM99.645 25.6825C99.645 24.8375 99.45 24.1225 99.125 23.4725C98.67 22.7575 98.085 22.3675 97.305 22.3675C96.46 22.3675 95.875 22.7575 95.42 23.4725C95.03 24.0575 94.9 24.8375 94.9 25.6825C94.9 26.5275 95.095 27.2425 95.42 27.8925C95.875 28.6075 96.46 28.9975 97.305 28.9975C98.085 28.9975 98.735 28.6075 99.125 27.8925C99.45 27.2425 99.645 26.5275 99.645 25.6825Z"
          fill="white"
        />
        <path
          d="M108.42 22.8763C108.225 22.8113 108.03 22.8113 107.77 22.8113C107.055 22.8113 106.47 23.0713 106.08 23.6563C105.755 24.1113 105.56 24.7613 105.56 25.4763V30.3514H103.48V24.0463C103.48 23.0063 103.48 22.0313 103.415 21.1213H105.235L105.3 22.8763H105.365C105.56 22.2913 105.95 21.7713 106.405 21.3813C106.86 21.0563 107.38 20.8613 107.9 20.8613C108.095 20.8613 108.29 20.8613 108.42 20.9263V22.8763Z"
          fill="white"
        />
        <path
          d="M117.585 25.2247C117.585 25.6147 117.585 25.8747 117.52 26.1347H111.345C111.345 27.0447 111.67 27.7597 112.255 28.2147C112.775 28.6697 113.425 28.8647 114.27 28.8647C115.18 28.8647 116.025 28.7347 116.74 28.4097L117.065 29.8397C116.22 30.2297 115.18 30.4247 113.945 30.4247C112.515 30.4247 111.41 30.0347 110.565 29.1897C109.72 28.3447 109.33 27.2397 109.33 25.8097C109.33 24.4447 109.72 23.2747 110.5 22.2997C111.28 21.3247 112.385 20.8047 113.75 20.8047C115.05 20.8047 116.09 21.3247 116.805 22.2997C117.325 23.0797 117.585 24.0547 117.585 25.2247ZM115.635 24.7047C115.635 24.1197 115.505 23.5997 115.245 23.1447C114.92 22.5597 114.335 22.2997 113.62 22.2997C112.97 22.2997 112.385 22.5597 111.995 23.1447C111.67 23.5997 111.475 24.1197 111.41 24.7697H115.635V24.7047Z"
          fill="white"
        />
        <path
          d="M47.1902 9.61556C47.1902 10.7206 46.8652 11.6306 46.1502 12.1506C45.5002 12.6706 44.6552 12.9306 43.4852 12.9306C42.9002 12.9306 42.4452 12.9306 41.9902 12.8656V6.69055C42.5102 6.62555 43.0952 6.56055 43.7452 6.56055C44.8502 6.56055 45.6952 6.82055 46.2152 7.27555C46.8652 7.79555 47.1902 8.57555 47.1902 9.61556ZM46.1502 9.61556C46.1502 8.90055 45.9552 8.31555 45.5652 7.92555C45.1752 7.53555 44.5902 7.34055 43.8752 7.34055C43.5502 7.34055 43.2902 7.34056 43.0302 7.40556V12.0855C43.1602 12.0855 43.3552 12.0855 43.6802 12.0855C44.4602 12.0855 45.0452 11.8905 45.5002 11.4355C45.9552 11.0455 46.1502 10.4606 46.1502 9.61556Z"
          fill="white"
        />
        <path
          d="M52.8453 10.6017C52.8453 11.3167 52.6504 11.9017 52.2604 12.2917C51.8704 12.7467 51.2853 13.0067 50.5703 13.0067C49.9203 13.0067 49.4003 12.8117 48.9453 12.3567C48.5553 11.9017 48.3604 11.3817 48.3604 10.6667C48.3604 9.95173 48.5553 9.36672 48.9453 8.91172C49.3353 8.45672 49.9203 8.26172 50.5703 8.26172C51.2203 8.26172 51.7403 8.45672 52.1953 8.91172C52.6503 9.36672 52.8453 9.88672 52.8453 10.6017ZM51.8053 10.6017C51.8053 10.2117 51.7403 9.82172 51.5453 9.49672C51.3503 9.10671 51.0254 8.97672 50.6354 8.97672C50.2454 8.97672 49.9204 9.17172 49.7254 9.49672C49.5304 9.82172 49.4654 10.1467 49.4654 10.6017C49.4654 10.9917 49.5304 11.3817 49.7254 11.7067C49.9204 12.0967 50.2454 12.2267 50.6354 12.2267C51.0254 12.2267 51.3503 12.0317 51.5453 11.7067C51.7403 11.3817 51.8053 11.0567 51.8053 10.6017Z"
          fill="white"
        />
        <path
          d="M60.3859 8.32227L58.9559 12.8723H58.0459L57.4609 10.9223C57.3309 10.4023 57.2009 9.94727 57.0709 9.42727C57.0059 9.94727 56.8759 10.4023 56.6809 10.9223L56.0309 12.8723H55.1209L53.7559 8.32227H54.7959L55.3159 10.4673C55.4459 10.9873 55.5109 11.4423 55.6409 11.8973C55.7059 11.5073 55.8359 11.0523 56.0309 10.4673L56.6809 8.32227H57.5259L58.1109 10.4673C58.2409 10.9873 58.3709 11.5073 58.5009 11.9623C58.5659 11.5073 58.6959 10.9873 58.8259 10.4673L59.3459 8.32227H60.3859Z"
          fill="white"
        />
        <path
          d="M65.6511 12.8767H64.6111V10.2767C64.6111 9.49672 64.2861 9.10673 63.7011 9.10673C63.3761 9.10673 63.1811 9.23673 62.9861 9.43173C62.7911 9.62673 62.7261 9.88672 62.7261 10.2117V12.8767H61.6861V9.62672C61.6861 9.23672 61.6861 8.78172 61.6211 8.32672H62.5311L62.5961 9.04173C62.7261 8.84673 62.9211 8.65171 63.1161 8.52171C63.3761 8.32671 63.7011 8.26172 64.0261 8.26172C64.4811 8.26172 64.8061 8.39172 65.0661 8.65172C65.3911 8.97672 65.5861 9.49672 65.5861 10.1467V12.8767H65.6511Z"
          fill="white"
        />
        <path
          d="M68.4443 12.8742H67.4043V6.24414H68.4443V12.8742Z"
          fill="white"
        />
        <path
          d="M74.36 10.6017C74.36 11.3167 74.165 11.9017 73.775 12.2917C73.385 12.7467 72.8 13.0067 72.085 13.0067C71.435 13.0067 70.915 12.8117 70.46 12.3567C70.07 11.9017 69.875 11.3817 69.875 10.6667C69.875 9.95173 70.07 9.36672 70.46 8.91172C70.85 8.45672 71.435 8.26172 72.085 8.26172C72.735 8.26172 73.255 8.45672 73.71 8.91172C74.165 9.36672 74.36 9.88672 74.36 10.6017ZM73.32 10.6017C73.32 10.2117 73.255 9.82172 73.06 9.49672C72.865 9.10671 72.54 8.97672 72.15 8.97672C71.76 8.97672 71.435 9.17172 71.24 9.49672C71.045 9.82172 70.98 10.1467 70.98 10.6017C70.98 10.9917 71.045 11.3817 71.24 11.7067C71.435 12.0967 71.76 12.2267 72.15 12.2267C72.54 12.2267 72.865 12.0317 73.06 11.7067C73.255 11.3817 73.32 11.0567 73.32 10.6017Z"
          fill="white"
        />
        <path
          d="M79.2357 12.8767H78.3257L78.2607 12.3567C77.9357 12.7467 77.4807 13.0067 76.9607 13.0067C76.5057 13.0067 76.1807 12.8767 75.9207 12.6167C75.6607 12.3567 75.5957 12.0317 75.5957 11.7067C75.5957 11.1217 75.8557 10.7317 76.3107 10.4067C76.7657 10.1467 77.4157 9.95172 78.2607 9.95172V9.88672C78.2607 9.30172 77.9357 8.97672 77.3507 8.97672C76.8957 8.97672 76.5057 9.10672 76.1807 9.30172L75.9857 8.65172C76.3757 8.39172 76.8957 8.26172 77.5457 8.26172C78.7157 8.26172 79.3007 8.91171 79.3007 10.1467V11.8367C79.1707 12.2917 79.2357 12.6167 79.2357 12.8767ZM78.1957 11.3167V10.6017C77.0907 10.6017 76.5057 10.8617 76.5057 11.5117C76.5057 11.7717 76.5707 11.9017 76.7007 12.0317C76.8307 12.1617 77.0257 12.2267 77.2207 12.2267C77.4157 12.2267 77.6757 12.1617 77.8057 12.0317C78.0007 11.9017 78.1307 11.7067 78.1307 11.5117C78.1957 11.4467 78.1957 11.3817 78.1957 11.3167Z"
          fill="white"
        />
        <path
          d="M85.0205 12.8742H84.1105L84.0455 12.1591C83.7855 12.7441 83.2655 13.0042 82.6155 13.0042C82.0955 13.0042 81.6405 12.8092 81.2505 12.3542C80.8605 11.8992 80.7305 11.3792 80.7305 10.6642C80.7305 9.94915 80.9255 9.36415 81.3155 8.90915C81.7055 8.45415 82.1605 8.25915 82.7455 8.25915C83.3305 8.25915 83.7855 8.45414 84.0455 8.84414V6.24414H85.0855V11.6392C84.9555 12.0942 84.9555 12.5492 85.0205 12.8742ZM83.9155 10.9892V10.2091C83.9155 10.0791 83.9155 9.94915 83.9155 9.88415C83.8505 9.62415 83.7205 9.42915 83.5255 9.29915C83.3305 9.10415 83.1355 9.03915 82.8755 9.03915C82.4855 9.03915 82.2255 9.16914 81.9655 9.49414C81.7705 9.81914 81.6405 10.1442 81.6405 10.6642C81.6405 11.1192 81.7705 11.5091 81.9655 11.7691C82.1605 12.0941 82.4855 12.2242 82.8755 12.2242C83.2005 12.2242 83.4605 12.0941 83.6555 11.8341C83.8505 11.5741 83.9155 11.3142 83.9155 10.9892Z"
          fill="white"
        />
        <path
          d="M93.6002 10.6017C93.6002 11.3167 93.4052 11.9017 93.0152 12.2917C92.6252 12.7467 92.0402 13.0067 91.3252 13.0067C90.6752 13.0067 90.1552 12.8117 89.7002 12.3567C89.3102 11.9017 89.1152 11.3817 89.1152 10.6667C89.1152 9.95173 89.3102 9.36672 89.7002 8.91172C90.0902 8.45672 90.6752 8.26172 91.3252 8.26172C91.9752 8.26172 92.4952 8.45672 92.9502 8.91172C93.4052 9.36672 93.6002 9.88672 93.6002 10.6017ZM92.5602 10.6017C92.5602 10.2117 92.4952 9.82172 92.3002 9.49672C92.1052 9.10671 91.7802 8.97672 91.3902 8.97672C91.0002 8.97672 90.6752 9.17172 90.4802 9.49672C90.2852 9.82172 90.2202 10.1467 90.2202 10.6017C90.2202 10.9917 90.2852 11.3817 90.4802 11.7067C90.6752 12.0967 91.0002 12.2267 91.3902 12.2267C91.7802 12.2267 92.1052 12.0317 92.3002 11.7067C92.4952 11.3817 92.5602 11.0567 92.5602 10.6017Z"
          fill="white"
        />
        <path
          d="M99.0593 12.8767H98.0193V10.2767C98.0193 9.49672 97.6943 9.10673 97.1093 9.10673C96.7843 9.10673 96.5893 9.23673 96.3943 9.43173C96.1993 9.62673 96.1343 9.88672 96.1343 10.2117V12.8767H95.0943V9.62672C95.0943 9.23672 95.0943 8.78172 95.0293 8.32672H95.9393L96.0043 9.04173C96.1343 8.84673 96.3293 8.65171 96.5243 8.52171C96.7843 8.32671 97.1093 8.26172 97.4343 8.26172C97.8893 8.26172 98.2143 8.39172 98.4743 8.65172C98.7993 8.97672 98.9943 9.49672 98.9943 10.1467V12.8767H99.0593Z"
          fill="white"
        />
        <path
          d="M105.82 9.10234H104.715V11.3123C104.715 11.8973 104.91 12.1573 105.3 12.1573C105.495 12.1573 105.625 12.1573 105.755 12.0923V12.8723C105.56 12.9373 105.3 13.0023 104.975 13.0023C104.585 13.0023 104.26 12.8723 104.065 12.6123C103.87 12.3523 103.74 11.9623 103.74 11.3773V9.10234H103.09V8.32234H103.74V7.47734L104.715 7.15234V8.25733H105.82V9.10234Z"
          fill="white"
        />
        <path
          d="M111.215 12.8742H110.175V10.2741C110.175 9.42915 109.85 9.03915 109.265 9.03915C108.81 9.03915 108.485 9.29916 108.29 9.75416C108.29 9.88416 108.225 9.94914 108.225 10.1441V12.8742H107.185V6.24414H108.225V8.97415C108.55 8.45415 109.005 8.25915 109.59 8.25915C109.98 8.25915 110.37 8.38915 110.63 8.64915C110.955 8.97415 111.15 9.49414 111.15 10.1441V12.8742H111.215Z"
          fill="white"
        />
        <path
          d="M116.675 10.4067C116.675 10.6017 116.675 10.7317 116.61 10.8617H113.555C113.555 11.3167 113.685 11.6417 114.01 11.9017C114.27 12.0967 114.595 12.2267 114.985 12.2267C115.44 12.2267 115.83 12.1617 116.22 12.0317L116.35 12.7467C115.895 12.9417 115.44 13.0067 114.855 13.0067C114.14 13.0067 113.62 12.8117 113.23 12.3567C112.84 11.9667 112.645 11.3817 112.645 10.6667C112.645 9.95173 112.84 9.43172 113.23 8.97672C113.62 8.52172 114.14 8.26172 114.79 8.26172C115.44 8.26172 115.96 8.52172 116.285 8.97672C116.545 9.36672 116.675 9.82173 116.675 10.4067ZM115.7 10.1467C115.7 9.82172 115.635 9.56173 115.505 9.36673C115.31 9.10673 115.049 8.97672 114.724 8.97672C114.399 8.97672 114.14 9.10673 113.945 9.36673C113.75 9.56173 113.685 9.82172 113.62 10.1467H115.7Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export const GooglePlaystoreIcon = () => {
  return (
    <div>
      <svg
        width="130"
        height="39"
        viewBox="0 0 130 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M125.19 38.48H4.81C2.145 38.48 0 36.335 0 33.67V4.81C0 2.145 2.145 0 4.81 0H125.19C127.855 0 130 2.145 130 4.81V33.67C130 36.335 127.855 38.48 125.19 38.48Z"
          fill="black"
        />
        <path
          d="M125.19 0.780008C127.4 0.780008 129.22 2.6 129.22 4.81V33.67C129.22 35.88 127.4 37.7 125.19 37.7H4.81C2.6 37.7 0.780008 35.88 0.780008 33.67V4.81C0.780008 2.6 2.6 0.780008 4.81 0.780008H125.19ZM125.19 0H4.81C2.145 0 0 2.145 0 4.81V33.67C0 36.335 2.145 38.48 4.81 38.48H125.19C127.855 38.48 130 36.335 130 33.67V4.81C130 2.145 127.855 0 125.19 0Z"
          fill="#A6A5A5"
        />
        <path
          d="M45.6303 9.81586C45.6303 10.5959 45.3703 11.2459 44.9153 11.7659C44.3953 12.3509 43.6803 12.6108 42.7703 12.6108C41.9253 12.6108 41.2103 12.3509 40.6253 11.7659C40.0403 11.1809 39.7803 10.4659 39.7803 9.62086C39.7803 8.77586 40.0403 8.06085 40.6253 7.47585C41.2103 6.89085 41.9253 6.63086 42.7703 6.63086C43.1603 6.63086 43.5503 6.69586 43.9403 6.89086C44.3303 7.02086 44.5903 7.28086 44.8503 7.54086L44.3303 8.06085C43.9403 7.60585 43.4203 7.34586 42.7703 7.34586C42.1853 7.34586 41.6653 7.54086 41.2103 7.99586C40.7553 8.45086 40.5603 8.97085 40.5603 9.68585C40.5603 10.4008 40.7553 10.9209 41.2103 11.3759C41.6653 11.8309 42.1853 12.0259 42.7703 12.0259C43.4203 12.0259 43.9403 11.8309 44.3953 11.3759C44.6553 11.1159 44.8503 10.7259 44.8503 10.2059H42.7703V9.49086H45.5653C45.6303 9.55586 45.6303 9.68586 45.6303 9.81586Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2963"
          strokeMiterlimit="10"
        />
        <path
          d="M50.1149 7.4103H47.5149V9.23031H49.9199V9.94531H47.4499V11.7653H50.0499V12.4803H46.6699V6.69531H50.0499V7.4103H50.1149Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2963"
          strokeMiterlimit="10"
        />
        <path
          d="M53.2355 12.4803H52.5205V7.4103H50.8955V6.69531H54.8605V7.4103H53.2355V12.4803Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2963"
          strokeMiterlimit="10"
        />
        <path
          d="M57.7207 12.4803V6.69531H58.4357V12.4803H57.7207Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2963"
          strokeMiterlimit="10"
        />
        <path
          d="M61.7502 12.4803H61.0352V7.4103H59.4102V6.69531H63.3752V7.4103H61.7502V12.4803Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2963"
          strokeMiterlimit="10"
        />
        <path
          d="M70.9153 11.7659C70.3303 12.3509 69.6153 12.6108 68.7703 12.6108C67.9253 12.6108 67.2103 12.3509 66.6253 11.7659C66.0403 11.1809 65.7803 10.4659 65.7803 9.62086C65.7803 8.77586 66.0403 8.06085 66.6253 7.47585C67.2103 6.89085 67.9253 6.63086 68.7703 6.63086C69.6153 6.63086 70.3303 6.95586 70.9153 7.54086C71.5003 8.12586 71.7603 8.84085 71.7603 9.68585C71.7603 10.4658 71.4353 11.1809 70.9153 11.7659ZM67.2103 11.2459C67.6653 11.7009 68.1853 11.8959 68.7703 11.8959C69.3553 11.8959 69.9403 11.7009 70.3303 11.2459C70.7853 10.7909 70.9803 10.2709 70.9803 9.55586C70.9803 8.84086 70.7853 8.32086 70.3303 7.86586C69.8753 7.41086 69.3553 7.21586 68.7703 7.21586C68.1853 7.21586 67.6003 7.41086 67.2103 7.86586C66.7553 8.32086 66.5603 8.84086 66.5603 9.55586C66.5603 10.2709 66.7553 10.8559 67.2103 11.2459Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2963"
          strokeMiterlimit="10"
        />
        <path
          d="M72.7998 12.4803V6.69531H73.7098L76.5048 11.1803V10.0753V6.69531H77.2198V12.4803H76.4398L73.5148 7.8003V8.90531V12.4803H72.7998Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2963"
          strokeMiterlimit="10"
        />
        <path
          d="M65.5845 20.9303C63.3095 20.9303 61.4895 22.6203 61.4895 25.0253C61.4895 27.3653 63.3095 29.1203 65.5845 29.1203C67.8595 29.1203 69.6795 27.3653 69.6795 25.0253C69.7445 22.6203 67.8595 20.9303 65.5845 20.9303ZM65.5845 27.4953C64.3495 27.4953 63.2445 26.4553 63.2445 25.0253C63.2445 23.5303 64.2845 22.5553 65.5845 22.5553C66.8845 22.5553 67.9245 23.5953 67.9245 25.0253C67.9245 26.4553 66.8845 27.4953 65.5845 27.4953ZM56.6145 20.9303C54.3395 20.9303 52.5195 22.6203 52.5195 25.0253C52.5195 27.3653 54.3395 29.1203 56.6145 29.1203C58.8895 29.1203 60.7095 27.3653 60.7095 25.0253C60.7745 22.6203 58.8895 20.9303 56.6145 20.9303ZM56.6145 27.4953C55.3795 27.4953 54.2745 26.4553 54.2745 25.0253C54.2745 23.5303 55.3145 22.5553 56.6145 22.5553C57.8495 22.5553 58.9545 23.5953 58.9545 25.0253C58.9545 26.4553 57.9145 27.4953 56.6145 27.4953ZM45.9545 22.1653V23.9203H50.1145C49.9845 24.8953 49.6595 25.6103 49.1395 26.1303C48.5545 26.7153 47.5795 27.4303 45.9545 27.4303C43.4195 27.4303 41.4045 25.3503 41.4045 22.8153C41.4045 20.2803 43.4195 18.2003 45.9545 18.2003C47.3195 18.2003 48.3595 18.7203 49.0745 19.4353L50.3095 18.2003C49.2695 17.2253 47.9045 16.4453 45.9545 16.4453C42.4445 16.4453 39.5195 19.3053 39.5195 22.8153C39.5195 26.3253 42.4445 29.1853 45.9545 29.1853C47.8395 29.1853 49.2695 28.5353 50.3745 27.4303C51.5445 26.2603 51.8695 24.7003 51.8695 23.3353C51.8695 22.9453 51.8695 22.5553 51.8045 22.2303H45.9545V22.1653ZM89.6346 23.5303C89.3096 22.6203 88.2695 20.9303 86.1245 20.9303C84.0445 20.9303 82.2895 22.6203 82.2895 25.0253C82.2895 27.3003 84.0446 29.1203 86.3846 29.1203C88.2696 29.1203 89.3745 27.9503 89.8295 27.3003L88.4645 26.3903C88.0095 27.1053 87.3595 27.4953 86.4495 27.4953C85.5395 27.4953 84.8896 27.1053 84.4346 26.2603L89.8945 23.9853L89.6346 23.5303ZM84.0445 24.8953C83.9795 23.3353 85.2795 22.4903 86.1895 22.4903C86.9045 22.4903 87.4896 22.8153 87.6846 23.3353L84.0445 24.8953ZM79.5596 28.8603H81.3795V16.8353H79.5596V28.8603ZM76.6346 21.8403C76.1796 21.3853 75.3995 20.9303 74.4245 20.9303C72.3445 20.9303 70.5245 22.7503 70.5245 25.0253C70.5245 27.3003 72.4095 29.1203 74.4245 29.1203C75.3995 29.1203 76.1795 28.6653 76.5695 28.2103H76.6346V28.7953C76.6346 30.3553 75.7895 31.2003 74.4245 31.2003C73.3195 31.2003 72.6695 30.4203 72.3445 29.7703L70.7845 30.4203C71.2395 31.5253 72.4095 32.8253 74.4245 32.8253C76.5045 32.8253 78.3245 31.5903 78.3245 28.5353V21.1903H76.6346V21.8403ZM74.5545 27.4953C73.3195 27.4953 72.2795 26.4553 72.2795 25.0253C72.2795 23.5953 73.3195 22.5553 74.5545 22.5553C75.7895 22.5553 76.7645 23.5953 76.7645 25.0253C76.7645 26.4553 75.7895 27.4953 74.5545 27.4953ZM98.0195 16.8353H93.7295V28.8603H95.5495V24.3103H98.0846C100.1 24.3103 102.05 22.8803 102.05 20.5403C102.05 18.2003 100.035 16.8353 98.0195 16.8353ZM98.0846 22.6203H95.5495V18.5253H98.0846C99.4496 18.5253 100.165 19.6303 100.165 20.6053C100.165 21.5153 99.4496 22.6203 98.0846 22.6203ZM109.2 20.9303C107.9 20.9303 106.535 21.5153 106.015 22.7503L107.64 23.4003C107.965 22.7503 108.615 22.4903 109.265 22.4903C110.175 22.4903 111.15 23.0753 111.15 24.0503V24.1803C110.825 23.9853 110.11 23.7253 109.265 23.7253C107.575 23.7253 105.82 24.7003 105.82 26.4553C105.82 28.0803 107.25 29.1203 108.81 29.1203C110.045 29.1203 110.695 28.6003 111.085 27.9503H111.15V28.8603H112.905V24.2453C112.84 22.1003 111.215 20.9303 109.2 20.9303ZM108.94 27.4953C108.355 27.4953 107.51 27.1703 107.51 26.4553C107.51 25.5453 108.55 25.1553 109.395 25.1553C110.175 25.1553 110.565 25.3503 111.02 25.5453C110.955 26.7153 109.98 27.4953 108.94 27.4953ZM119.145 21.1903L117.065 26.3903H117L114.855 21.1903H112.905L116.09 28.4703L114.27 32.5003H116.155L121.095 21.1253H119.145V21.1903ZM102.96 28.8603H104.78V16.8353H102.96V28.8603Z"
          fill="white"
        />
        <path
          d="M10.0741 7.27594C9.81415 7.60094 9.61914 8.05595 9.61914 8.64095V29.896C9.61914 30.481 9.81415 30.9359 10.0741 31.2609L10.1392 31.3259L22.0341 19.4309V19.2359V19.1059L10.1392 7.21094L10.0741 7.27594Z"
          fill="#5BC8F3"
        />
        <path
          d="M25.9992 23.3306L22.0342 19.3656V19.2356V19.1056L25.9992 15.1406L26.0642 15.2056L30.7442 17.8706C32.1092 18.6506 32.1092 19.8856 30.7442 20.6656L26.0642 23.3306H25.9992Z"
          fill="url(#paint0_linear_4979_13571)"
        />
        <path
          d="M26.1292 23.3313L22.0342 19.2363L10.0742 31.1963C10.5292 31.6513 11.2442 31.7163 12.0892 31.2613L26.1292 23.3313Z"
          fill="url(#paint1_linear_4979_13571)"
        />
        <path
          d="M26.1292 15.1414L12.0892 7.14642C11.2442 6.69142 10.5292 6.75642 10.0742 7.21142L22.0342 19.1714L26.1292 15.1414Z"
          fill="url(#paint2_linear_4979_13571)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4979_13571"
            x1="29.9364"
            y1="19.2359"
            x2="6.65506"
            y2="19.2359"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFDF00" />
            <stop offset="0.4087" stop-color="#FBBC0E" />
            <stop offset="0.7754" stop-color="#F9A418" />
            <stop offset="1" stop-color="#F89B1C" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_4979_13571"
            x1="23.8947"
            y1="21.4445"
            x2="1.99738"
            y2="43.3418"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#EE4447" />
            <stop offset="1" stop-color="#C5166C" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_4979_13571"
            x1="1.89981"
            y1="-4.96678"
            x2="19.7783"
            y2="12.9117"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#269E6F" />
            <stop offset="0.05089" stop-color="#2BA06F" />
            <stop offset="0.4663" stop-color="#53B26B" />
            <stop offset="0.7971" stop-color="#6BBD69" />
            <stop offset="1" stop-color="#74C168" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export const IconBattery = () => {
  return (
    <div>
      <svg
        width="66"
        height="38"
        viewBox="0 0 66 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4358_13741)">
          <path
            d="M14.932 12.2109H9.48242V25.7824H14.932V12.2109Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.831 12.2109H20.3813V25.7824H25.831V12.2109Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M36.7304 12.2109H31.2808V25.7824H36.7304V12.2109Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M47.6293 12.2109H42.1797V25.7824H47.6293V12.2109Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M58.5832 12.2126V2.71261C58.5832 1.95261 57.9838 1.35547 57.2208 1.35547H2.72471C1.96176 1.35547 1.3623 1.95261 1.3623 2.71261V35.284C1.3623 36.044 1.96176 36.6412 2.72471 36.6412H57.2208C57.9838 36.6412 58.5832 36.044 58.5832 35.284V25.784H62.6704C63.4334 25.784 64.0328 25.1869 64.0328 24.4269V13.5698C64.0328 12.8098 63.4334 12.2126 62.6704 12.2126H58.5832Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4358_13741">
            <rect width="65.3953" height="38" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const IconStep = () => {
  return (
    <div>
      <svg
        width="58"
        height="44"
        viewBox="0 0 58 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4358_13700)">
          <path
            d="M33.1597 5.13885C36.5765 8.58019 44.0245 14.1109 47.0234 1.23047C47.0234 1.23047 53.1933 2.06622 54.9877 12.8081C54.9877 12.8081 57.4704 18.5847 55.4056 19.5433C53.3408 20.502 36.7486 33.702 25.0972 36.455C13.4458 39.2081 -4.76875 39.7489 3.17092 32.2025C10.8648 24.902 22.6391 27.2863 30.0871 5.58131C30.505 4.35226 32.2502 4.20477 33.1597 5.13885Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.229 35.4233L1.37649 38.8892C1.45023 40.4378 2.5318 41.7652 4.03124 42.1584C8.75079 43.3875 17.8458 42.6009 25.0972 41.126C35.0279 39.1104 49.7519 28.516 55.086 24.9026C56.2167 24.1406 56.8067 22.8132 56.6592 21.4858L56.2413 18.6836"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.7598 22.1484L42.2547 28.3428"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.3564 18.707L47.2693 25.0735"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4358_13700">
            <rect width="57.9128" height="44" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const IconGPSDevice = () => {
  return (
    <div>
      <svg
        width="25"
        height="50"
        viewBox="0 0 25 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4358_13714)">
          <path
            d="M16.2372 8.70969C14.0695 6.39885 10.4294 6.39885 8.26172 8.70969"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.8998 4.72366C16.1759 -0.204762 8.34356 -0.204762 3.61963 4.72366"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.2698 39.4488C14.4044 39.4488 16.1348 37.7184 16.1348 35.5838C16.1348 33.4492 14.4044 31.7188 12.2698 31.7188C10.1352 31.7188 8.40479 33.4492 8.40479 35.5838C8.40479 37.7184 10.1352 39.4488 12.2698 39.4488Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.045 13.6797H2.49485C1.68167 13.6797 1.02246 14.3389 1.02246 15.1521V47.5038C1.02246 48.317 1.68167 48.9762 2.49485 48.9762H22.045C22.8581 48.9762 23.5173 48.317 23.5173 47.5038V15.1521C23.5173 14.3389 22.8581 13.6797 22.045 13.6797Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.27 20.2461V26.3811"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.9487 22.293V26.3829"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.59082 22.293V26.3829"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6484 24.3359V26.3809"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.91211 24.3359V26.3809"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4358_13714">
            <rect width="24.5399" height="50" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const AvatarImage = ({ height = "80", width = "80" }) => {
  return (
    <div>
      <svg
        width={width}
        height={height}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="40" cy="40" r="40" fill="#BEBEBE" />
        <path
          d="M60.5692 61.1437C53.8393 58.3533 47.3282 55.1251 46.699 53.1006V50.3922C48.5046 48.5593 49.8998 45.9877 50.7479 42.9784C52.745 41.5831 53.2648 38.6559 51.596 36.6041V30.5307C51.596 24.2385 48.0942 19.9434 40.1058 19.9434C32.1174 19.9434 28.6157 24.2385 28.6157 30.5307V36.6041C26.9469 38.6559 27.4667 41.5831 29.4638 42.9784C30.3118 45.9877 31.7071 48.5319 33.5127 50.3922V53.1006C32.8834 55.1524 26.7554 58.1618 19.9434 60.9796"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="40" cy="40" r="30" stroke="#242A34" strokeWidth="2" />
      </svg>
    </div>
  );
};

export const CrossIconBtn = ({ className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.390524 0.390524C0.911223 -0.130175 1.75544 -0.130175 2.27614 0.390524L9.33333 7.44772L16.3905 0.390524C16.9112 -0.130175 17.7554 -0.130175 18.2761 0.390524C18.7968 0.911223 18.7968 1.75544 18.2761 2.27614L11.219 9.33333L18.2761 16.3905C18.7968 16.9112 18.7968 17.7554 18.2761 18.2761C17.7554 18.7968 16.9112 18.7968 16.3905 18.2761L9.33333 11.219L2.27614 18.2761C1.75544 18.7968 0.911223 18.7968 0.390524 18.2761C-0.130175 17.7554 -0.130175 16.9112 0.390524 16.3905L7.44772 9.33333L0.390524 2.27614C-0.130175 1.75544 -0.130175 0.911223 0.390524 0.390524Z"
          fill={blackTextColor}
        />
      </svg>
    </div>
  );
};

export const IconTracking = ({
  onClick,
  className,
  color = "#DB4E3B",
  height = "32",
  width = "25",
}) => {
  return (
    <div onClick={onClick} className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 25 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 32C12.5 32 24.5 20.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 20.6274 12.5 32 12.5 32ZM12.5 18C9.18629 18 6.5 15.3137 6.5 12C6.5 8.68629 9.18629 6 12.5 6C15.8137 6 18.5 8.68629 18.5 12C18.5 15.3137 15.8137 18 12.5 18Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export const ArrowRight = ({ className, color = "#DB4E3B" }) => {
  return (
    <div className={className}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 19 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.66562 18.0487C8.03113 17.4133 8.03113 16.383 8.66562 15.7476L14.4047 10.0001L8.66562 4.25249C8.03113 3.61707 8.03113 2.58685 8.66562 1.95143C9.3001 1.31601 10.3288 1.31601 10.9633 1.95143L19.0001 10.0001L10.9633 18.0487C10.3288 18.6841 9.3001 18.6841 8.66562 18.0487Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export const RightFill = ({
  className,
  color = "#DB4E3B",
  width = "32",
  height = "32",
}) => {
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8365 24.8366 32 16 32C7.16344 32 0 24.8365 0 16C0 7.16344 7.16344 0 16 0ZM9 15C8.44771 15 8 15.4477 8 16C8 16.5523 8.44771 17 9 17L20.5858 17L16.2929 21.2929C15.9024 21.6834 15.9024 22.3166 16.2929 22.7071C16.6834 23.0976 17.3166 23.0976 17.7071 22.7071L23.7071 16.7071C24.0976 16.3166 24.0976 15.6834 23.7071 15.2929L17.7071 9.29289C17.3166 8.90237 16.6834 8.90237 16.2929 9.29289C15.9024 9.68341 15.9024 10.3166 16.2929 10.7071L20.5858 15H9Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export const IconEdit = ({ onClick, className, color = "#595252" }) => {
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.2804 0.21967C18.9875 -0.0732233 18.5126 -0.0732233 18.2197 0.21967L15.75 2.68935L21.3107 8.25001L23.7804 5.78033C24.0732 5.48744 24.0732 5.01256 23.7804 4.71967L19.2804 0.21967Z"
          fill={color}
        />
        <path
          d="M20.25 9.31067L14.6894 3.75001L4.93936 13.5H5.25C5.66421 13.5 6 13.8358 6 14.25V15H6.75C7.16421 15 7.5 15.3358 7.5 15.75V16.5H8.25C8.66421 16.5 9 16.8358 9 17.25V18H9.75C10.1642 18 10.5 18.3358 10.5 18.75V19.0607L20.25 9.31067Z"
          fill={color}
        />
        <path
          d="M9.04748 20.5132C9.01679 20.4313 9 20.3426 9 20.25V19.5H8.25C7.83579 19.5 7.5 19.1642 7.5 18.75V18H6.75C6.33579 18 6 17.6642 6 17.25V16.5H5.25C4.83579 16.5 4.5 16.1642 4.5 15.75V15H3.75C3.6574 15 3.56872 14.9832 3.48683 14.9525L3.21969 15.2197C3.14787 15.2915 3.09139 15.3772 3.05366 15.4715L0.0536643 22.9715C-0.0577607 23.25 0.00754483 23.5682 0.219692 23.7803C0.431839 23.9925 0.750002 24.0578 1.02856 23.9464L8.52856 20.9464C8.62287 20.9086 8.70853 20.8521 8.78035 20.7803L9.04748 20.5132Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export const IconTrash = ({
  onClick,
  className,
  color = "#F3F4F6",
  width = "24",
  height = "24",
}) => {
  return (
    <div className={className} onClick={onClick}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5 2.25V3.75H21.75C22.1642 3.75 22.5 4.08579 22.5 4.5C22.5 4.91421 22.1642 5.25 21.75 5.25H20.9424L19.6633 21.2392C19.5385 22.7983 18.2369 24 16.6728 24H7.32719C5.76311 24 4.46147 22.7983 4.33674 21.2392L3.0576 5.25H2.25C1.83579 5.25 1.5 4.91421 1.5 4.5C1.5 4.08579 1.83579 3.75 2.25 3.75H7.5V2.25C7.5 1.00736 8.50736 0 9.75 0H14.25C15.4926 0 16.5 1.00736 16.5 2.25ZM9 2.25V3.75H15V2.25C15 1.83579 14.6642 1.5 14.25 1.5H9.75C9.33579 1.5 9 1.83579 9 2.25ZM6.74998 7.54275L7.49998 20.2928C7.52431 20.7063 7.87923 21.0217 8.29273 20.9974C8.70623 20.9731 9.02172 20.6182 8.99739 20.2047L8.24739 7.45467C8.22307 7.04117 7.86814 6.72568 7.45465 6.75C7.04115 6.77433 6.72566 7.12925 6.74998 7.54275ZM16.5453 6.75129C16.1318 6.72697 15.7769 7.04246 15.7526 7.45596L15.0026 20.206C14.9783 20.6195 15.2938 20.9744 15.7073 20.9987C16.1208 21.023 16.4757 20.7075 16.5 20.294L17.25 7.54404C17.2743 7.13054 16.9588 6.77562 16.5453 6.75129ZM12 6.75C11.5858 6.75 11.25 7.08579 11.25 7.5V20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V7.5C12.75 7.08579 12.4142 6.75 12 6.75Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export const ChangesSavedIcon = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.44 8C17.44 12.4183 13.5359 16 8.72 16C3.90408 16 0 12.4183 0 8C0 3.58172 3.90408 0 8.72 0C13.5359 0 17.44 3.58172 17.44 8ZM13.1131 4.96967C12.7938 4.67678 12.2762 4.67678 11.9569 4.96967C11.9492 4.97674 11.942 4.98424 11.9352 4.9921L8.15036 9.41674L5.86843 7.32322C5.54917 7.03033 5.03156 7.03033 4.71231 7.32322C4.39305 7.61612 4.39305 8.09099 4.71231 8.38388L7.59693 11.0303C7.91619 11.3232 8.4338 11.3232 8.75305 11.0303C8.76016 11.0238 8.76687 11.0169 8.77315 11.0097L13.1247 6.01947C13.4323 5.72582 13.4284 5.25897 13.1131 4.96967Z"
        fill="#B8CD82"
      />
    </svg>
  );
};

export const IconQuestion = ({
  onClick,
  className,
  fillColor,
  width = "20",
  height = "20",
}) => {
  return (
    <div onClick={onClick} className={className} style={{ cursor: 'pointer'}}>
      <svg width={width} height={height} fill="none" viewBox="0 0 20 20">
        <path
          stroke={fillColor || blackTextColor}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.25"
          d="M10 18.625a8.625 8.625 0 1 0 0-17.25 8.625 8.625 0 0 0 0 17.25Z"
        />
        <path
          stroke={fillColor || "#6B6B6B"}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M10.233 14.947v-.24M10.233 12.306V10.84c0-.227.147-.427.36-.507 1.32-.466 2.427-1.186 2.427-2.4 0-1.326-1.22-2.4-2.733-2.4-1.014 0-1.9.487-2.374 1.214"
        />
      </svg>
    </div>
  );
};

export const DragHandleIcon = ({ className, width = "38", height = "48" }) => {
  // Convert string dimensions to numbers for calculations
  const w = parseFloat(width);
  const h = parseFloat(height);
  
  // Calculate scale factors based on original dimensions (38x48)
  const scaleX = w / 38;
  const scaleY = h / 48;
  
  // Scale the path coordinates
  const scaledPath = `M0 ${10 * scaleY}C0 ${4.47715 * scaleY} ${4.47715 * scaleX} 0 ${10 * scaleX} 0H${w}V${h}H${10 * scaleX}C${4.47715 * scaleX} ${h} 0 ${43.5228 * scaleY} 0 ${38 * scaleY}V${10 * scaleY}Z`;
  
  // Scale circle positions and radii
  const circles = [
    { cx: 14.2853 * scaleX, cy: 14.8576 * scaleY, r: 2.57143 * Math.min(scaleX, scaleY) },
    { cx: 23.714 * scaleX, cy: 14.8576 * scaleY, r: 2.57143 * Math.min(scaleX, scaleY) },
    { cx: 14.2853 * scaleX, cy: 24.0001 * scaleY, r: 2.57143 * Math.min(scaleX, scaleY) },
    { cx: 23.714 * scaleX, cy: 24.0001 * scaleY, r: 2.57143 * Math.min(scaleX, scaleY) },
    { cx: 14.2853 * scaleX, cy: 33.1437 * scaleY, r: 2.57143 * Math.min(scaleX, scaleY) },
    { cx: 23.714 * scaleX, cy: 33.1437 * scaleY, r: 2.57143 * Math.min(scaleX, scaleY) }
  ];

  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${w} ${h}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={scaledPath}
          fill={blackTextColor}
        />
        {circles.map((circle, index) => (
          <circle 
            key={index}
            cx={circle.cx} 
            cy={circle.cy} 
            r={circle.r} 
            fill="white" 
          />
        ))}
      </svg>
    </div>
  );
};

export const IconSmallQuestion = ({
  onClick,
  className,
  fillColor,
  width = "14",
  height = "14",
}) => {
  return (
    <div onClick={onClick} className={className}>
      <svg width={width} height={height} fill="none" viewBox="0 0 20 20">
        <path
          stroke={fillColor || "#6B6B6B"}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.25"
          d="M10 18.625a8.625 8.625 0 1 0 0-17.25 8.625 8.625 0 0 0 0 17.25Z"
        />
        <path
          stroke={fillColor || "#6B6B6B"}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M10.233 14.947v-.24m0-2.401V10.84c0-.227.147-.427.36-.507 1.32-.466 2.427-1.186 2.427-2.4 0-1.326-1.22-2.4-2.733-2.4-1.014 0-1.9.487-2.374 1.214"
        />
      </svg>
    </div>
  );
};

export const ArrowRepeat = ({
  onClick,
  className,
  color = "#595252",
  width = "49",
  height = "48",
}) => {
  return (
    <div onClick={onClick} className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 49 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <path
            d="M35.101 21H46.8985C47.5344 21 47.8817 21.7416 47.4747 22.2301L41.5759 29.3086C41.2761 29.6684 40.7234 29.6684 40.4236 29.3086L34.5249 22.2301C34.1178 21.7416 34.4652 21 35.101 21Z"
            fill={color}
          />
          <path
            d="M2.10104 27H13.8985C14.5344 27 14.8817 26.2584 14.4746 25.7699L8.57593 18.6914C8.27608 18.3316 7.72344 18.3316 7.4236 18.6914L1.52488 25.7699C1.1178 26.2584 1.46517 27 2.10104 27Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.4998 9C19.8423 9 15.6815 11.1209 12.9278 14.4552C12.4003 15.0939 11.4548 15.1841 10.8161 14.6566C10.1773 14.129 10.0872 13.1836 10.6147 12.5448C13.9138 8.55008 18.9096 6 24.4998 6C33.3249 6 40.6638 12.3495 42.203 20.729C42.2196 20.8191 42.2355 20.9094 42.2507 21H39.2C37.811 14.1533 31.7557 9 24.4998 9ZM9.79952 27C11.1886 33.8467 17.2439 39 24.4998 39C29.1572 39 33.3181 36.8791 36.0717 33.5448C36.5992 32.9061 37.5447 32.8159 38.1834 33.3434C38.8222 33.871 38.9124 34.8164 38.3848 35.4552C35.0857 39.4499 30.0899 42 24.4998 42C15.6747 42 8.3357 35.6505 6.79651 27.271C6.77996 27.1809 6.76408 27.0906 6.74888 27H9.79952Z"
            fill={color}
          />
        </g>
      </svg>
    </div>
  );
};

export const EyeFill = ({
  onClick,
  className,
  color = "white",
  width = "24",
  height = "25",
}) => {
  return (
    <div onClick={onClick} className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.75 12.5C15.75 14.5711 14.0711 16.25 12 16.25C9.92893 16.25 8.25 14.5711 8.25 12.5C8.25 10.4289 9.92893 8.75 12 8.75C14.0711 8.75 15.75 10.4289 15.75 12.5Z"
          fill={color}
        />
        <path
          d="M0 12.5C0 12.5 4.5 4.25 12 4.25C19.5 4.25 24 12.5 24 12.5C24 12.5 19.5 20.75 12 20.75C4.5 20.75 0 12.5 0 12.5ZM12 17.75C14.8995 17.75 17.25 15.3995 17.25 12.5C17.25 9.6005 14.8995 7.25 12 7.25C9.1005 7.25 6.75 9.6005 6.75 12.5C6.75 15.3995 9.1005 17.75 12 17.75Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export const IconMediumQuestion = ({ onClick, className }) => {
  return (
    <div onClick={onClick} className={className}>
      <svg width="16" height="16" fill="none" viewBox="0 0 20 20">
        <path
          d="M10 18.623A8.619 8.619 0 0 0 18.623 10 8.619 8.619 0 0 0 10 1.377 8.619 8.619 0 0 0 1.377 10 8.619 8.619 0 0 0 10 18.623Zm0 0"
          style="fill: none; stroke-width: 1.25; stroke-linecap: round; stroke-linejoin: round; stroke: #6B6B6B; stroke-opacity: 1; stroke-miterlimit: 4;"
          transform="scale(0.8)"
        />
        <path
          d="M10.234 14.946v-.239m0-2.402V10.84c0-.225.147-.425.357-.508 1.323-.464 2.427-1.186 2.427-2.397 0-1.329-1.216-2.403-2.73-2.403-1.016 0-1.9.489-2.373 1.216"
          style="fill: none; stroke-width: 1.5; stroke-linecap: round; stroke-linejoin: round; stroke: #6B6B6B; stroke-opacity: 1; stroke-miterlimit: 4;"
          transform="scale(0.8)"
        />
      </svg>
    </div>
  );
};

export const IconEmergency = () => {
  return (
    <div>
      <svg
        width="43"
        height="24"
        viewBox="0 0 43 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4184_9047)">
          <path
            d="M4.55719 13.8203V15.4639H5.69649V19.4234H8.40466"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M38.2506 19.5359H41.9299V11.6916C41.9299 11.318 41.7058 11.0005 41.3883 10.8137L35.1875 8.12426L30.8545 1.49391C30.6677 1.1764 30.3128 0.970948 29.9206 0.970948L4.57587 0.933594V2.74527"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.7074 19.5361H30.9478"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.6085 23.0663C36.6257 23.0663 38.2506 21.4227 38.2506 19.4242C38.2506 17.4258 36.607 15.7822 34.6085 15.7822C32.6101 15.7822 30.9665 17.4258 30.9665 19.4242C30.9665 21.4227 32.6101 23.0663 34.6085 23.0663Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.0467 23.0663C14.0638 23.0663 15.6887 21.4227 15.6887 19.4242C15.6887 17.4258 14.0451 15.7822 12.0467 15.7822C10.0482 15.7822 8.40466 17.4258 8.40466 19.4242C8.40466 21.4227 10.0482 23.0663 12.0467 23.0663Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.53695 10.1973H2.80154"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.933838 6.46191H8.40465"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.919 10.1978H25.1206V4.59473H28.221L31.919 10.1978Z"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.726 4.91211V12.6818"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.8412 8.79688H19.6109"
            stroke="#242A34"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4184_9047">
            <rect width="42.8638" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const IconReport = ({ className }) => {
  return (
    <div className={className}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.26977 4.92013C5.60977 3.05013 5.76977 3.11013 5.13977 4.92013C3.13977 4.96013 3.24977 4.84013 4.78977 5.99013C4.20977 7.88013 4.11977 7.75013 5.70977 6.65013C7.29977 7.75013 7.20977 7.88013 6.62977 5.99013C8.21977 4.79013 8.20977 4.96013 6.27977 4.92013H6.26977Z"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.26977 11.9201C5.60977 10.0501 5.76977 10.1101 5.13977 11.9201C3.13977 11.9601 3.24977 11.8401 4.78977 12.9901C4.20977 14.8801 4.11977 14.7401 5.70977 13.6501C7.29977 14.7501 7.20977 14.8801 6.62977 12.9901C8.21977 11.7901 8.20977 11.9601 6.27977 11.9201H6.26977Z"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.26977 18.9201C5.61977 17.0601 5.76977 17.1001 5.13977 18.9201C3.13977 18.9601 3.24977 18.8401 4.78977 19.9901C4.20977 21.8801 4.11977 21.7401 5.70977 20.6501C7.29977 21.7501 7.20977 21.8801 6.62977 19.9901C8.21977 18.8001 8.21977 18.9601 6.27977 18.9201H6.26977Z"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 19.5H22.44"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 12.5H22.44"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 5.5H22.44"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25 1H1V25H25V1Z"
          stroke="#242A34"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    </div>
  );
};

export const IconBilling = ({ className }) => {
  return (
    <div className={className}>
      <svg
        width="17"
        height="28"
        viewBox="0 0 17 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 3.17422V27H15.5967V3.17422H15.5627L13.1394 1L10.716 3.17422L8.29268 1L5.86934 3.17422L3.44599 1L1.02265 3.17422H1Z"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.42761 22.5039H11.101"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.42761 19.1074H11.101"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.42761 13.7513C6.05043 14.2949 7.01298 14.7025 7.70375 14.7025C8.8135 14.7025 9.71943 13.9212 9.71943 12.9473C9.71943 11.9735 8.75688 11.4978 7.70375 11.1921C6.61664 10.8524 5.68807 10.4107 5.68807 9.43687C5.68807 8.463 6.59399 7.68164 7.70375 7.68164C8.45113 7.68164 9.10793 8.04401 9.44765 8.56492"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.70374 6.70703V7.66957"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.70374 14.7021V15.6647"
          stroke="#242A34"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconEmergencyexf = () => {
  return <div></div>;
};

export const IconMenu = ({
  className,
  onClick,
  color = "#F3F4F6",
  height = "20",
  width = "38",
}) => {
  return (
    <div className={className} onClick={onClick} color={color}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1H37"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 10H37"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 19H37"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconPowerOff = ({ color = "#6b6b6b" }) => {
  return (
    <div>
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M37.0469 22.913H28.7017"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.1167 18.0922L37.0471 22.913L32.1167 27.7522"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.6539 1H5.34609C2.94581 1 1 2.94581 1 5.34609V38.6539C1 41.0542 2.94581 43 5.34609 43H38.6539C41.0542 43 43 41.0542 43 38.6539V5.34609C43 2.94581 41.0542 1 38.6539 1Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.0226 12.7235C22.6757 13.8557 21.4705 14.4948 20.32 14.1296C19.1879 13.7826 18.5487 12.5774 18.9139 11.427C19.2609 10.2948 20.4661 9.65566 21.6166 10.0209C22.7487 10.3678 23.3879 11.5731 23.0226 12.7235Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.261 35.6226C19.261 35.6226 19.261 30.82 19.1515 29.2861C19.1515 29.0122 19.0236 28.7565 18.8228 28.5556L15.2619 24.94C14.9697 24.4287 14.9149 23.8261 15.0975 23.2782L16.5401 18.64C16.8871 17.5078 18.0558 16.7409 19.2062 16.9965C20.521 17.2887 21.0506 18.4939 20.8862 19.8817L20.3201 24.7574L24.5567 24.8304"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8189 27.3687L12.0476 30.0713H7.2085"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.819 17.4165H12.0842L9.65552 21.8539"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconInfo = ({ color = "#F3F4F6" }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 256 256"
      >
        <path
          fill="#fff"
          strokeMiterlimit={10}
          d="M12 2C6.489 2 2 6.489 2 12s4.489 10 10 10 10-4.489 10-10S17.511 2 12 2zm0 2c4.43 0 8 3.57 8 8s-3.57 8-8 8-8-3.57-8-8 3.57-8 8-8zm-1 3v2h2V7zm0 4v6h2v-6z"
          fontFamily="none"
          fontSize="none"
          fontWeight="none"
          style={{
            mixBlendMode: "normal",
          }}
          textAnchor="none"
          transform="scale(10.66667)"
        />
      </svg>
    </div>
  );
};

export const IconReorder = () => {
  return (
    <div>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5210_19811)">
          <path
            d="M7.25977 3.24L9.98977 0.5L12.7298 3.24"
            stroke="#242A34"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 8.57V0.5"
            stroke="#242A34"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.5 8.56995H19.5"
            stroke="#242A34"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.74 16.83L10.01 19.57L7.27002 16.83"
            stroke="#242A34"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 11.5V19.57"
            stroke="#242A34"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5 11.5H0.5"
            stroke="#242A34"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5210_19811">
            <rect width="20" height="20.07" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const IconUpDown = ({ className, onClick }) => {
  return (
    <div onClick={onClick} className={className}>
      <svg
        width="14"
        height="19"
        viewBox="0 0 14 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 12.6572L5.94975 17.607C6.34027 17.9975 6.97344 17.9975 7.36396 17.607L12.3137 12.6572"
          stroke="#6B6B6B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3135 6.65723L7.36373 1.70748C6.9732 1.31695 6.34004 1.31695 5.94952 1.70748L0.999768 6.65723"
          stroke="#6B6B6B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconDropDown = (props) => {
  return (
    <div className={props?.className}>
      <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 5.65686L5.94975 10.6066C6.34027 10.9971 6.97344 10.9971 7.36396 10.6066L12.3137 5.65686"
          stroke={props?.color || "#6B6B6B"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconDropUp = ({ className }) => {
  return (
    <div className={className}>
      <svg
        width="14"
        height="13"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3137 6.65686L7.36397 1.70711C6.97345 1.31659 6.34028 1.31659 5.94976 1.70711L1.00001 6.65686"
          stroke="#6B6B6B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const AlertIcon = ({ props }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        style={{
          enableBackground: "new 0 0 122.88 98.02",
        }}
        viewBox="0 0 122.88 98.02"
        {...props}
      >
        <defs>
          <path
            id="a"
            d="M64.65.68a5.68 5.68 0 0 1 2.41 2.2l53.66 84.17c.02.02.03.05.05.07.47.75.87 1.6 1.2 2.54.31.89.57 1.88.77 2.96.1.52.14.98.14 1.38 0 .98-.24 1.81-.72 2.49-.55.78-1.33 1.26-2.33 1.45-.3.06-.59.08-.87.08H3.92c-.28 0-.57-.03-.87-.08-1-.19-1.78-.67-2.33-1.45C.24 95.81 0 94.98 0 94c0-.4.05-.86.15-1.38.2-1.08.45-2.06.77-2.96.33-.94.73-1.78 1.2-2.54l.02-.03 53.68-84.2.01-.02c.6-.98 1.41-1.71 2.41-2.2.93-.45 2-.68 3.21-.68s2.27.24 3.2.69z"
          />
        </defs>
        <clipPath id="b">
          <use
            xlinkHref="#a"
            style={{
              overflow: "visible",
            }}
          />
        </clipPath>
        <g
          style={{
            clipPath: "url(#b)",
          }}
        >
          <defs>
            <path id="c" d="M0 0h122.88v98.02H0z" />
          </defs>
          <clipPath id="d">
            <use
              xlinkHref="#c"
              style={{
                overflow: "visible",
              }}
            />
          </clipPath>
          <g
            style={{
              clipPath: "url(#d)",
            }}
          >
            <image
              xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAPJAAAE9QAABu3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIANIBBwMBIgACEQEDEQH/ xACiAAEBAQEBAQEAAAAAAAAAAAAAAQMCBAUGAQEAAwEBAAAAAAAAAAAAAAAAAwQFAQIQAAECAwcE AwEAAAAAAAAAAAACAxIzFDBAARETBDQQIDJDMURFUBEAAQMDAwUBAQAAAAAAAAAAAAExAlCRsXGB A/ARQcGCITISAAECAwYGAQUAAAAAAAAAAAABAkAxMnGRsQMzgxGBEnKCcyFBYSITY//aAAwDAQAC EQMRAAAA/Z585YFvdgj9bsBuwG7AbsBuwG7AbsBuwG7AbsBuwG7AbsBuwH0GbXrYZa5Y1oI+gAAA AAAAAAAAAAewbdXDLXLIshH0AAAAAAAAAAAAAD2Dbq4Za5ZFkI+gAAAAAAAAAAAAAewbdXDLbLIs QR+gAAAAAAAAAAAAAPYNurjltnk2OVRdiiKIoiiKIp2KIoiiKIoiiKID2Dbq5Z655U0VF6k6HLoc rTlRFEURRFEURRFEU7FEUeobVbPPXPLlio/UVxFEURRyoiiKIoiiKIoiiKIo9I2q+fGmeXKEfQAJ QiudiiKIoiiKIoiiKIoij0DZgz474y5Qj6AAAAAAAAAAAAlEobq2IMuO+MuYI+gAAAAAAAAAAAAA egbEGXHfGXMEfQAAAAAAAAAAAAAPQNiDLjTjMlivHYoiiKIoiiKIoiiKIoiiKIoijca8O4ueAAAA AAAAAAAAAAAAP//aAAgBAgABBQB7cv4O1T5VPlU+VT5VPlU+VT5VPlU+VT5VPlU+VT5VPlU+Rron 51v+e/Ot/wA9+db/AJ7863/PfnW/57863+g/Nt/oPTbf6L023+i9Nt/ovTbf6LycdWHEhxIcSHEh xIcSHEhxIcSHEhxIcSHEhxIcTLGiuP8A/9oACAEDAAEFAEoTDpoNNBpoNNBpoNNBpoNNBpoNNBpo NNBpoNNBpoMsNVHjb+5Hjb+5Hjb+5Hjb+5Pjb+5Pjb+1Pjb+1Pxb+xPxb+xPxb+xPxb+xPxb+y4/ /9oACAEBAAEFAH906h2tfK18rXytfK18rXytfK18rXytfK18rXytfK18rXytfK18rXytfK18rXyt fK18rXytfK18rXytfK18rXytfGnlr2+6n3/b8PdT7/t+Hup9/wBvw91Pv+34e6n3/b8PdT7/ALfh 7qff9vw91Pv+34e5n3/b8Pcz7+xxNzPscumXTLrl0yssurHE3E7uy6ZWWVqxxdxO65duXZkZdmRl 0y6ZdcumXXIZ4r87tyssumXbl25djPGfm2mVzZ4z82/tcd6bf2uO9Nv7XHem39qQ9Nv7Uh6bf2pD 02/tSHpt/akPTb+1Iewx1IVEKiFRCohUQqIVEKiFRCohUQqIVEKiFRCohUQqIVEKiFRCohUQqIVE KiFRCohUQqIVDeGOh/B//9oACAECAgY/AMxEzHoiPcifP3NV95qvvNV95qvvNV95qvvNV95qvvNV 95qvvNV95qvvNV95qvvNV9519S9X6uPV9eJmex2MBtGZ7HYwG0ZnsdjAbRmex2MBtGZ7HYwG0Zns djAbRmex2MBtGZ3uxgNozO92MBtGZ3uxgNozO92MBtGZ8LW7EkpJSSklJKSUkpJSSklJKSUkpJSS nD+UF//aAAgBAwIGPwBPxSSFKFKFKFKFKFKFKFKFKFKFKFKFKFKFKHDh8dQ2xIDyG2JAeQ2xIDyG 2JAeQliQHkJYkB5CWQHkJZAcxLIDmJZAcxLIDmJZAc4L/9oACAEBAQY/AJRj27I34Olh0sOlh0sO lh0sOlh0sOlh0sOlh0sOlh0sOlh0sOlh0sOlh0sOlh0sOlh0sOlh0sOlh0sOlh0sOlifIv8AUe/b ZCevqgcmksE9fVA5NJYJ6+qByaSwT19UDk0lgnr6oHJpLBPX1QOTSWCevqgcmksE9fVA5NJYJ9eK ByaSwT68UDk+sEuvFA5PrBLrxQJ/WCXXigT+sEqBP6wSoE/rBKgT3wSoE98EqBLfBKgS3wSoEt8E qBLfBKgS3wSoEt8EqBLfBL8UZRlGUZRlGUZRlGUZRlGUZRlGUZRlGUZRlGUZRlGUZRlGUZRlGUZS Sdv39xQv/9k="
              width={260}
              height={207}
              style={{
                overflow: "visible",
              }}
              transform="matrix(.48 0 0 -.48 -.69 98.662)"
            />
          </g>
        </g>
        <path
          d="M57.71 74.18c.98-.95 2.15-1.42 3.32-1.51.78-.06 1.56.07 2.29.34.72.27 1.38.7 1.93 1.24.86.86 1.45 2.03 1.55 3.39a5.52 5.52 0 0 1-.48 2.62c-.62 1.33-1.63 2.23-2.78 2.71-.7.29-1.45.42-2.2.4-.75-.02-1.49-.19-2.16-.5a5.343 5.343 0 0 1-2.69-2.8 5.42 5.42 0 0 1-.34-1.21c-.07-.43-.09-.85-.06-1.25v-.01c.04-.56.24-1.29.54-1.92.26-.57.63-1.11 1.08-1.5zm7.78-9.77c-.07 1.69-1.18 2.75-2.59 3.21-.48.16-.98.23-1.47.23-.48 0-.99-.08-1.47-.23-1.41-.45-2.52-1.52-2.58-3.21-.78-7.83-2.79-20.13-2.72-27.5.07-2.27 1.95-3.61 4.35-4.12.74-.16 1.56-.24 2.38-.23.83 0 1.64.08 2.39.24 2.48.53 4.44 1.93 4.44 4.24l-.01.23-2.72 27.14z"
          style={{
            fill: "#35464e",
          }}
        />
      </svg>
    </div>
  );
};

export const IconCalender = ({ className, onClick, fillColor }) => {
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 0H3C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H21C22.6569 24 24 22.6569 24 21V3C24 1.34315 22.6569 0 21 0ZM1.5 5.78571C1.5 5.07563 2.17157 4.5 3 4.5H21C21.8284 4.5 22.5 5.07563 22.5 5.78571V21.2143C22.5 21.9244 21.8284 22.5 21 22.5H3C2.17157 22.5 1.5 21.9244 1.5 21.2143V5.78571Z"
          fill={fillColor || "#595252"}
        />
        <path
          d="M9.75 10.5C10.5784 10.5 11.25 9.82843 11.25 9C11.25 8.17157 10.5784 7.5 9.75 7.5C8.92157 7.5 8.25 8.17157 8.25 9C8.25 9.82843 8.92157 10.5 9.75 10.5Z"
          fill={fillColor || "#595252"}
        />
        <path
          d="M14.25 10.5C15.0784 10.5 15.75 9.82843 15.75 9C15.75 8.17157 15.0784 7.5 14.25 7.5C13.4216 7.5 12.75 8.17157 12.75 9C12.75 9.82843 13.4216 10.5 14.25 10.5Z"
          fill={fillColor || "#595252"}
        />
        <path
          d="M18.75 10.5C19.5784 10.5 20.25 9.82843 20.25 9C20.25 8.17157 19.5784 7.5 18.75 7.5C17.9216 7.5 17.25 8.17157 17.25 9C17.25 9.82843 17.9216 10.5 18.75 10.5Z"
          fill={fillColor || "#595252"}
        />
        <path
          d="M5.25 15C6.07843 15 6.75 14.3284 6.75 13.5C6.75 12.6716 6.07843 12 5.25 12C4.42157 12 3.75 12.6716 3.75 13.5C3.75 14.3284 4.42157 15 5.25 15Z"
          fill={fillColor || "#595252"}
        />
        <path
          d="M9.75 15C10.5784 15 11.25 14.3284 11.25 13.5C11.25 12.6716 10.5784 12 9.75 12C8.92157 12 8.25 12.6716 8.25 13.5C8.25 14.3284 8.92157 15 9.75 15Z"
          fill={fillColor || "#595252"}
        />
        <path
          d="M14.25 15C15.0784 15 15.75 14.3284 15.75 13.5C15.75 12.6716 15.0784 12 14.25 12C13.4216 12 12.75 12.6716 12.75 13.5C12.75 14.3284 13.4216 15 14.25 15Z"
          fill={fillColor || "#595252"}
        />
        <path
          d="M18.75 15C19.5784 15 20.25 14.3284 20.25 13.5C20.25 12.6716 19.5784 12 18.75 12C17.9216 12 17.25 12.6716 17.25 13.5C17.25 14.3284 17.9216 15 18.75 15Z"
          fill={fillColor || "#595252"}
        />
        <path
          d="M5.25 19.5C6.07843 19.5 6.75 18.8284 6.75 18C6.75 17.1716 6.07843 16.5 5.25 16.5C4.42157 16.5 3.75 17.1716 3.75 18C3.75 18.8284 4.42157 19.5 5.25 19.5Z"
          fill={fillColor || "#595252"}
        />
        <path
          d="M9.75 19.5C10.5784 19.5 11.25 18.8284 11.25 18C11.25 17.1716 10.5784 16.5 9.75 16.5C8.92157 16.5 8.25 17.1716 8.25 18C8.25 18.8284 8.92157 19.5 9.75 19.5Z"
          fill={fillColor || "#595252"}
        />
        <path
          d="M14.25 19.5C15.0784 19.5 15.75 18.8284 15.75 18C15.75 17.1716 15.0784 16.5 14.25 16.5C13.4216 12 12.75 12.6716 12.75 13.5C12.75 14.3284 13.4216 15 14.25 15Z"
          fill={fillColor || "#595252"}
        />
      </svg>
    </div>
  );
};

export const IconBillingCards = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={259}
        height={30}
        fill="none"
      >
        <path fill="url(#a)" d="M0 0h258.529v30H0z" />
        <defs>
          <pattern
            id="a"
            width={1}
            height={1}
            patternContentUnits="objectBoundingBox"
          >
            <use xlinkHref="#b" transform="matrix(.00104 0 0 .00893 -.001 0)" />
          </pattern>
          <image
            xlinkHref="data:image/png;base64,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"
            id="b"
            width={968}
            height={112}
          />
        </defs>
      </svg>
    </div>
  );
};

export const IconAlert = () => {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width={24} height={22}>
        <path
          d="M13.805 1.152c.488.418.789.953 1.093 1.516.067.117.13.234.196.352.031.054.058.109.094.167.109.204.226.399.34.598.214.363.429.73.636 1.098.035.058.066.117.102.176l.203.355.492.856c.066.113.129.226.195.34.032.058.063.113.098.171.293.508.293.508.39.68.063.113.13.226.192.34.164.281.328.566.492.851.313.547.625 1.09.942 1.637.28.484.558.969.835 1.457.27.477.543.953.817 1.426.32.55.637 1.101.953 1.652.133.23.262.457.39.684.067.113.13.226.196.336.148.265.3.527.453.789.055.09.106.183.16.273.067.117.137.23.203.344.453.781.641 1.543.48 2.441-.237.832-.745 1.438-1.487 1.856-.489.234-.954.265-1.493.265h-4.519c-1 .004-2 .004-3 0-.914 0-1.828 0-2.742.004H6.117c-.449.004-.898.004-1.347 0h-.688c-.207.004-.418.004-.629 0h-.226c-.856.008-1.543-.246-2.168-.836-.516-.55-.754-1.21-.762-1.96l-.008-.122c-.004-.628.254-1.164.563-1.695a82.063 82.063 0 0 1 .395-.691c.062-.106.12-.211.183-.313.117-.207.238-.414.36-.62.19-.333.382-.661.57-.993.035-.055.066-.113.097-.172.066-.113.133-.226.2-.344.16-.28.323-.566.488-.847.062-.114.128-.227.19-.34.134-.227.263-.453.392-.68.03-.058.066-.113.097-.172.067-.113.13-.226.196-.34.164-.28.324-.566.488-.851.344-.602.687-1.2 1.035-1.797.32-.55.64-1.105.957-1.66.16-.285.324-.567.488-.852.063-.113.13-.226.196-.34a344.215 344.215 0 0 1 1.265-2.207c.063-.113.13-.226.192-.336.152-.261.3-.523.445-.789.055-.09.105-.183.156-.273.063-.113.125-.23.188-.344.437-.777 1-1.308 1.851-1.578a2.93 2.93 0 0 1 2.524.488Zm0 0"
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#f8ba08",
            fillOpacity: 1,
          }}
        />
        <path
          d="M12.984 5.781c.434.29.727.61.887 1.117.07.758-.055 1.54-.133 2.293-.015.137-.027.27-.043.407-.027.277-.054.558-.086.84-.035.32-.066.644-.097.968-.035.313-.067.625-.098.938-.016.133-.027.265-.039.394l-.059.555c-.007.055-.011.11-.015.164-.114 1.047-.114 1.047-.469 1.383-.297.215-.59.308-.953.289-.383-.07-.629-.277-.856-.59-.136-.262-.18-.543-.21-.832-.008-.105-.008-.105-.02-.207-.008-.074-.012-.148-.02-.223l-.023-.23-.059-.617-.058-.606-.117-1.191c-.02-.192-.036-.387-.055-.578-.016-.145-.027-.293-.043-.438-.008-.101-.02-.199-.027-.297-.043-.41-.079-.824-.114-1.234a1.922 1.922 0 0 1-.015-.156c-.055-.668-.075-1.203.363-1.75.574-.594 1.602-.79 2.36-.399Zm0 0"
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#2d313e",
            fillOpacity: 1,
          }}
        />
        <path
          d="M12.95 15.852c.5.308.866.714 1.023 1.289.058.605.02 1.129-.348 1.64-.332.395-.742.707-1.266.778-.441.035-.855.02-1.242-.223l-.16-.09c-.414-.328-.727-.738-.828-1.27-.031-.464-.05-.902.207-1.308.023-.035.047-.07.07-.11.586-.835 1.606-1.167 2.543-.706Zm0 0"
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#2d313d",
            fillOpacity: 1,
          }}
        />
        <path
          d="M10.441 1.047c.036.016.07.031.106.05-.223.223-.445.45-.676.68-.035-.02-.07-.035-.105-.054.074-.082.148-.164.222-.25.04-.047.082-.094.121-.141.106-.113.207-.2.332-.285Zm0 0"
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#8e7600",
            fillOpacity: 1,
          }}
        />
      </svg>
    </div>
  );
};

export const ToggleOff = ({ className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="34"
        height="20"
        viewBox="0 0 34 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="34"
          y="18"
          width="30"
          height="16"
          rx="8"
          transform="rotate(-180 34 18)"
          fill={blackTextColor}
        />
        <circle
          cx="10"
          cy="10"
          r="9.5"
          transform="rotate(-180 10 10)"
          fill="#F3F4F6"
          stroke={blackTextColor}
        />
      </svg>
    </div>
  );
};

export const ToggleOn = ({ className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="34"
        height="20"
        viewBox="0 0 34 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="2" width="30" height="16" rx="8" fill="#B8CD82" />
        <circle cx="24" cy="10" r="9.5" fill="#F3F4F6" stroke="#B8CD82" />
      </svg>
    </div>
  );
};

export const IconPlus = ({ className, color = "#000000" }) => {
  return (
    <div className={className}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 1V15M1 8H15"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const SubscriberDetailIcon = (props) => {
  const { className, width = "32", height = "32" } = props;
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16Z"
          fill="#DB4E3B"
        />
        <path
          d="M2 28C2 28 0 28 0 26C0 24 2 18 12 18C22 18 24 24 24 26C24 28 22 28 22 28H2Z"
          fill="#DB4E3B"
        />
        <path
          d="M22 7C22 6.44772 22.4477 6 23 6H31C31.5523 6 32 6.44772 32 7C32 7.55228 31.5523 8 31 8H23C22.4477 8 22 7.55228 22 7Z"
          fill="#DB4E3B"
        />
        <path
          d="M23 12C22.4477 12 22 12.4477 22 13C22 13.5523 22.4477 14 23 14H31C31.5523 14 32 13.5523 32 13C32 12.4477 31.5523 12 31 12H23Z"
          fill="#DB4E3B"
        />
        <path
          d="M27 18C26.4477 18 26 18.4477 26 19C26 19.5523 26.4477 20 27 20H31C31.5523 20 32 19.5523 32 19C32 18.4477 31.5523 18 31 18H27Z"
          fill="#DB4E3B"
        />
        <path
          d="M27 24C26.4477 24 26 24.4477 26 25C26 25.5523 26.4477 26 27 26H31C31.5523 26 32 25.5523 32 25C32 24.4477 31.5523 24 31 24H27Z"
          fill="#DB4E3B"
        />
      </svg>
    </div>
  );
};

export const BillingIcon = (props) => {
  const { className, width = "32", height = "32" } = props;
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.83982 1.01292C4.15711 0.961435 4.47981 1.06561 4.70711 1.29291L6 2.5858L7.29289 1.29291C7.68342 0.902381 8.31658 0.902381 8.70711 1.29291L10 2.5858L11.2929 1.29291C11.6834 0.902381 12.3166 0.902381 12.7071 1.29291L14 2.5858L15.2929 1.29291C15.6834 0.902381 16.3166 0.902381 16.7071 1.29291L18 2.5858L19.2929 1.29291C19.6834 0.902381 20.3166 0.902381 20.7071 1.29291L22 2.5858L23.2929 1.29291C23.6834 0.902381 24.3166 0.902381 24.7071 1.29291L26 2.5858L27.2929 1.29291C27.5202 1.06561 27.8429 0.961435 28.1602 1.01292C28.4775 1.06441 28.7507 1.26529 28.8944 1.5528L29.8944 3.5528C29.9639 3.69165 30 3.84477 30 4.00001V28C30 28.1553 29.9639 28.3084 29.8944 28.4472L28.8944 30.4472C28.7507 30.7347 28.4775 30.9356 28.1602 30.9871C27.8429 31.0386 27.5202 30.9344 27.2929 30.7071L26 29.4142L24.7071 30.7071C24.3166 31.0976 23.6834 31.0976 23.2929 30.7071L22 29.4142L20.7071 30.7071C20.3166 31.0976 19.6834 31.0976 19.2929 30.7071L18 29.4142L16.7071 30.7071C16.3166 31.0976 15.6834 31.0976 15.2929 30.7071L14 29.4142L12.7071 30.7071C12.3166 31.0976 11.6834 31.0976 11.2929 30.7071L10 29.4142L8.70711 30.7071C8.31658 31.0976 7.68342 31.0976 7.29289 30.7071L6 29.4142L4.70711 30.7071C4.47981 30.9344 4.15711 31.0386 3.83982 30.9871C3.52252 30.9356 3.24933 30.7347 3.10557 30.4472L2.10557 28.4472C2.03615 28.3084 2 28.1553 2 28V4.00001C2 3.84477 2.03615 3.69165 2.10557 3.5528L3.10557 1.5528C3.24933 1.26529 3.52252 1.06441 3.83982 1.01292ZM4.27395 3.68818L4 4.23608V27.7639L4.27395 28.3118L5.29289 27.2929C5.68342 26.9024 6.31658 26.9024 6.70711 27.2929L8 28.5858L9.29289 27.2929C9.68342 26.9024 10.3166 26.9024 10.7071 27.2929L12 28.5858L13.2929 27.2929C13.6834 26.9024 14.3166 26.9024 14.7071 27.2929L16 28.5858L17.2929 27.2929C17.6834 26.9024 18.3166 26.9024 18.7071 27.2929L20 28.5858L21.2929 27.2929C21.6834 26.9024 22.3166 26.9024 22.7071 27.2929L24 28.5858L25.2929 27.2929C25.6834 26.9024 26.3166 26.9024 26.7071 27.2929L27.726 28.3118L28 27.7639V4.23608L27.726 3.68818L26.7071 4.70712C26.3166 5.09764 25.6834 5.09764 25.2929 4.70712L24 3.41423L22.7071 4.70712C22.3166 5.09764 21.6834 5.09764 21.2929 4.70712L20 3.41423L18.7071 4.70712C18.3166 5.09764 17.6834 5.09764 17.2929 4.70712L16 3.41423L14.7071 4.70712C14.3166 5.09764 13.6834 5.09764 13.2929 4.70712L12 3.41423L10.7071 4.70712C10.3166 5.09764 9.68342 5.09764 9.29289 4.70712L8 3.41423L6.70711 4.70712C6.31658 5.09764 5.68342 5.09764 5.29289 4.70712L4.27395 3.68818Z"
          fill="#DB4E3B"
        />
        <path
          d="M6 9.00001C6 8.44773 6.44772 8.00001 7 8.00001H19C19.5523 8.00001 20 8.44773 20 9.00001C20 9.5523 19.5523 10 19 10H7C6.44772 10 6 9.5523 6 9.00001ZM6 13C6 12.4477 6.44772 12 7 12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14H7C6.44772 14 6 13.5523 6 13ZM6 17C6 16.4477 6.44772 16 7 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H7C6.44772 18 6 17.5523 6 17ZM6 21C6 20.4477 6.44772 20 7 20H19C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H7C6.44772 22 6 21.5523 6 21Z"
          fill="#DB4E3B"
        />
        <path
          d="M22 9.00001C22 8.44773 22.4477 8.00001 23 8.00001H25C25.5523 8.00001 26 8.44773 26 9.00001C26 9.5523 25.5523 10 25 10H23C22.4477 10 22 9.5523 22 9.00001ZM22 13C22 12.4477 22.4477 12 23 12H25C25.5523 12 26 12.4477 26 13C26 13.5523 25.5523 14 25 14H23C22.4477 14 22 13.5523 22 13ZM22 17C22 16.4477 22.4477 16 23 16H25C25.5523 16 26 16.4477 26 17C26 17.5523 25.5523 18 25 18H23C22.4477 18 22 17.5523 22 17ZM22 21C22 20.4477 22.4477 20 23 20H25C25.5523 20 26 20.4477 26 21C26 21.5523 25.5523 22 25 22H23C22.4477 22 22 21.5523 22 21Z"
          fill="#DB4E3B"
        />
      </svg>
    </div>
  );
};

export const EmergencyIcon = (props) => {
  const { className, width = "32", height = "28" } = props;
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8768 2.03139C15.9116 2.0121 15.955 2 16.0031 2C16.0512 2 16.0946 2.0121 16.1293 2.03139C16.1593 2.04806 16.199 2.07852 16.2388 2.14625L29.9527 25.4796C30.024 25.6009 30.0226 25.728 29.957 25.8463C29.9241 25.9056 29.8829 25.9447 29.8475 25.9667C29.8181 25.9849 29.7801 26 29.717 26H2.28918C2.22607 26 2.18809 25.9849 2.15864 25.9667C2.12326 25.9447 2.08211 25.9056 2.04922 25.8463C1.98361 25.728 1.98217 25.6009 2.05349 25.4796L15.7674 2.14625C15.8072 2.07852 15.8469 2.04806 15.8768 2.03139ZM17.963 1.13284C17.0753 -0.377614 14.9309 -0.377614 14.0432 1.13284L0.329252 24.4662C-0.584814 26.0214 0.512557 28 2.28918 28H29.717C31.4936 28 32.591 26.0214 31.6769 24.4662L17.963 1.13284Z"
          fill="#DB4E3B"
        />
        <path
          d="M14.0031 22C14.0031 20.8954 14.8985 20 16.0031 20C17.1077 20 18.0031 20.8954 18.0031 22C18.0031 23.1046 17.1077 24 16.0031 24C14.8985 24 14.0031 23.1046 14.0031 22Z"
          fill="#DB4E3B"
        />
        <path
          d="M14.199 9.99008C14.0925 8.92457 14.9292 8 16 8C17.0708 8 17.9075 8.92457 17.801 9.99007L17.0995 17.005C17.043 17.5698 16.5677 18 16 18C15.4323 18 14.957 17.5698 14.9005 17.005L14.199 9.99008Z"
          fill="#DB4E3B"
        />
      </svg>
    </div>
  );
};

export const ShippingIcon = (props) => {
  const { className, width = "32", height = "32" } = props;
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.3714 2.22582C16.133 2.13046 15.867 2.13046 15.6286 2.22582L3.69258 7.00023L8.5 8.9232L20.8074 4.00023L16.3714 2.22582ZM23.5 5.07726L11.1926 10.0002L16 11.9232L28.3074 7.00023L23.5 5.07726ZM30 8.47726L17 13.6773V29.5232L30 24.3232V8.47726ZM15 29.5232V13.6773L2 8.47726V24.3232L15 29.5232ZM14.8858 0.368867C15.6011 0.0827736 16.3989 0.0827735 17.1142 0.368867L31.3714 6.07175C31.751 6.22362 32 6.59133 32 7.00023V24.3232C32 25.141 31.5021 25.8764 30.7428 26.1802L16.3714 31.9287C16.133 32.0241 15.867 32.0241 15.6286 31.9287L1.25722 26.1802C0.497902 25.8764 0 25.141 0 24.3232V7.00023C0 6.59133 0.248951 6.22362 0.628609 6.07175L14.8858 0.368867Z"
          fill="#DB4E3B"
        />
      </svg>
    </div>
  );
};

export const SignalHistoryIcon = (props) => {
  const { className, width = "32", height = "32" } = props;
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29 6C29.5523 6 30 6.44772 30 7V25C30 25.5523 29.5523 26 29 26H3C2.44772 26 2 25.5523 2 25V7C2 6.44772 2.44772 6 3 6H29ZM3 4C1.34315 4 0 5.34315 0 7V25C0 26.6569 1.34315 28 3 28H29C30.6569 28 32 26.6569 32 25V7C32 5.34315 30.6569 4 29 4H3Z"
          fill="#DB4E3B"
        />
        <path
          d="M14 11C14 10.4477 14.4477 10 15 10H25C25.5523 10 26 10.4477 26 11C26 11.5523 25.5523 12 25 12H15C14.4477 12 14 11.5523 14 11Z"
          fill="#DB4E3B"
        />
        <path
          d="M11.0071 9.29289C11.3976 9.68342 11.3976 10.3166 11.0071 10.7071L8.00711 13.7071C7.61659 14.0976 6.98342 14.0976 6.5929 13.7071L5.5929 12.7071C5.20237 12.3166 5.20237 11.6834 5.5929 11.2929C5.98342 10.9024 6.61659 10.9024 7.00711 11.2929L7.3 11.5858L9.5929 9.29289C9.98342 8.90237 10.6166 8.90237 11.0071 9.29289Z"
          fill="#DB4E3B"
        />
        <path
          d="M14 19C14 18.4477 14.4477 18 15 18H25C25.5523 18 26 18.4477 26 19C26 19.5523 25.5523 20 25 20H15C14.4477 20 14 19.5523 14 19Z"
          fill="#DB4E3B"
        />
        <path
          d="M11.0071 17.2929C11.3976 17.6834 11.3976 18.3166 11.0071 18.7071L8.00711 21.7071C7.61659 22.0976 6.98342 22.0976 6.5929 21.7071L5.5929 20.7071C5.20237 20.3166 5.20237 19.6834 5.5929 19.2929C5.98342 18.9024 6.61659 18.9024 7.00711 19.2929L7.3 19.5858L9.5929 17.2929C9.98342 16.9024 10.6166 16.9024 11.0071 17.2929Z"
          fill="#DB4E3B"
        />
      </svg>
    </div>
  );
};

// Next page loader icon (used in Alerts paging loader)
export const NextPageLoaderIcon = ({ className, width = "48", height = "48" }) => {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.5">
          <path d="M34.601 21H46.3985C47.0344 21 47.3817 21.7416 46.9747 22.2301L41.0759 29.3086C40.7761 29.6684 40.2234 29.6684 39.9236 29.3086L34.0249 22.2301C33.6178 21.7416 33.9652 21 34.601 21Z" fill="#595252"/>
          <path d="M1.60104 27H13.3985C14.0344 27 14.3817 26.2584 13.9746 25.7699L8.07593 18.6914C7.77608 18.3316 7.22344 18.3316 6.9236 18.6914L1.02488 25.7699C0.617797 26.2584 0.965166 27 1.60104 27Z" fill="#595252"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9998 9C19.3423 9 15.1815 11.1209 12.4278 14.4552C11.9003 15.0939 10.9548 15.1841 10.3161 14.6566C9.67733 14.129 9.58715 13.1836 10.1147 12.5448C13.4138 8.55008 18.4096 6 23.9998 6C32.8249 6 40.1638 12.3495 41.703 20.729C41.7196 20.8191 41.7355 20.9094 41.7507 21H38.7C37.311 14.1533 31.2557 9 23.9998 9ZM9.29952 27C10.6886 33.8467 16.7439 39 23.9998 39C28.6572 39 32.8181 36.8791 35.5717 33.5448C36.0992 32.9061 37.0447 32.8159 37.6834 33.3434C38.3222 33.871 38.4124 34.8164 37.8848 35.4552C34.5857 39.4499 29.5899 42 23.9998 42C15.1747 42 7.8357 35.6505 6.29651 27.271C6.27996 27.1809 6.26408 27.0906 6.24888 27H9.29952Z" fill="#595252"/>
        </g>
      </svg>
    </div>
  );
};

export const PreviousIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width={12}
      height={12}
      fill={props?.isInActive ? "#6b6b6b" : "#fff"}
      baseProfile="tiny"
      viewBox="0 0 42 42"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M27.066 1 7 21.068l19.568 19.569 4.934-4.933-14.637-14.636L32 5.933z"
      />
    </svg>
  )
}

export const NextIcon = (props) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width={11}
      height={11}
      fill={props?.isInActive ? "#6b6b6b" : "#fff"}
      viewBox="0 0 199.404 199.404"
      {...props}
    >
      <path d="m63.993 199.404 99.702-99.702L63.993 0 35.709 28.285l71.418 71.417-71.418 71.417z" />
    </svg>
  );
}
export const BackArrow = (props) => {
  return (
    <div
      className={props?.className}
      style={{
        marginTop: "-15px",
      }}
      onClick={props?.onClick}
    >
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,512.000000) scale(0.0586,-0.0586)"
          fill="#000000"
          stroke="none"
        >
          <path
            d="M854 5105 c-159 -29 -279 -77 -410 -166 -199 -134 -344 -340 -412
-588 l-27 -96 0 -1695 0 -1695 27 -96 c103 -375 379 -646 755 -742 l88 -22
1690 0 1690 0 96 27 c375 103 646 379 742 755 l22 88 0 1690 0 1690 -27 96
c-101 368 -368 636 -733 737 l-100 27 -1665 2 c-1323 1 -1679 -1 -1736 -12z
m3376 -400 c235 -54 410 -226 470 -461 20 -75 20 -118 20 -1684 0 -1566 0
-1609 -20 -1684 -58 -227 -229 -398 -456 -456 -75 -20 -118 -20 -1684 -20
-1566 0 -1609 0 -1684 20 -237 60 -408 236 -460 470 -15 68 -16 220 -14 1705
3 1472 5 1634 20 1675 89 249 250 391 503 444 11 2 745 4 1630 5 1391 1 1619
-1 1675 -14z"
          />
          <path
            d="M2106 3706 c-31 -12 -149 -124 -503 -478 -532 -531 -518 -513 -518
-663 0 -160 -25 -128 504 -658 256 -258 480 -476 496 -484 17 -9 55 -16 85
-17 103 -1 188 74 198 173 9 96 6 100 -346 454 l-327 327 1095 0 c1043 0 1097
1 1135 19 157 72 152 299 -7 366 -33 13 -166 15 -1130 15 l-1093 0 327 328
c352 353 355 357 346 453 -12 122 -148 207 -262 165z"
          />
        </g>
      </svg>
    </div>
  );
};

export const IconRunDataVerification = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" stroke="#FFFFFF" stroke-width="2" />
      <path d="M10 8L16 12L10 16V8Z" fill="#FFFFFF" />
    </svg>
  );
};

export const IconMapPin = (props) => {
  const { className, width = "32", height = "32" } = props || {};
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M16 32C16 32 28 20.6274 28 12C28 5.37258 22.6274 0 16 0C9.37258 0 4 5.37258 4 12C4 20.6274 16 32 16 32ZM16 18C12.6863 18 10 15.3137 10 12C10 8.68629 12.6863 6 16 6C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18Z"
          fill="#595252"
        />
      </svg>
    </div>
  );
};
